/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.6.2.0 (NJsonSchema v10.1.23.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { BaseClientApi, ClientApiConfig,ApiException } from '@eta/components';
import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export interface ITaxpayerManagementPublicClient {
    /**
     * @return Success
     */
    internaltaxpayers(rin: string | null): Promise<number>;
    /**
     * @param body (optional) 
     * @return Success
     */
    validateTaxpayerOtp(rin: string | null, otp: string | null, body?: ValidateTaxpayerOtpRequest | undefined): Promise<ValidateTaxpayerOTPResponse>;
    /**
     * @return Success
     */
    checkDelegationInvitationIsExist(invitationId: string | null): Promise<CheckDelegationInvitationValidityQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    registerDelegate(body?: RegisterDelegateDto | undefined): Promise<RegisterDelegateResponseDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateSystemDelegate(body?: UpdateSystemDelegateRequest | undefined): Promise<UpdateSystemDelegateResponseDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateTaxpayerStatus(rin: string | null, body?: TaxpayerStatusUpdateDto | undefined): Promise<TaxpayerStatusUpdateResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateDelegateStatus(body?: DelegetesStatusUpdateDto | undefined): Promise<DelegetesStatusUpdateResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    createDelegates(rin: string | null, body?: RepresentationInvitationModel | undefined): Promise<RegisterDelegateResponseDto>;
    /**
     * @param rin (optional) 
     * @param name (optional) 
     * @param bdistrict (optional) 
     * @param bgover (optional) 
     * @param isactive (optional) 
     * @param email (optional) 
     * @param mobileno (optional) 
     * @param type (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param ps (optional) 
     * @param pn (optional) 
     * @return Success
     */
    queryTaxpayers(rin?: string | null | undefined, name?: string | null | undefined, bdistrict?: number | null | undefined, bgover?: number | null | undefined, isactive?: boolean | null | undefined, email?: string | null | undefined, mobileno?: string | null | undefined, type?: string | null | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined, ps?: number | undefined, pn?: number | undefined): Promise<GetTaxPayersResponseDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    acceptInvitation(invitationID: string | null, body?: AccetpInvitationDto | undefined): Promise<AcceptDelegationInvitationResponseDto>;
    /**
     * @return Success
     */
    getTaxpayerByrin(rin: string | null): Promise<GetTaxpayerByRinResponseDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    registerTaxpayer(rin: string | null, body?: CreateProfileForTaxpayerRequest | undefined): Promise<CreateProfileForExistTaxpayerResponseDto>;
    /**
     * @return Success
     */
    getCurrentTaxpayerDetails(): Promise<GetCurrentTaxpayerResponseDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateCompanyDetails(body?: UpdateCompanyProfileRequest | undefined): Promise<number>;
    /**
     * @param language (optional) 
     * @return Success
     */
    config(language?: string | null | undefined): Promise<GetLookupResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    completeUserProfile(body?: CreateUserProfileDto | undefined): Promise<CreateUserProfileResponse>;
    /**
     * @param name (optional) 
     * @param status (optional) 
     * @param profType (optional) 
     * @param email (optional) 
     * @param mobileNo (optional) 
     * @param natId (optional) 
     * @param taxpayerRep (optional) 
     * @param certId (optional) 
     * @param representFrom (optional) 
     * @param representTo (optional) 
     * @param ps (optional) 
     * @param pn (optional) 
     * @param ordDir (optional) 
     * @return Success
     */
    queryUsers(name?: string | null | undefined, status?: StatusTypes | undefined, profType?: ProfileTypes | undefined, email?: string | null | undefined, mobileNo?: string | null | undefined, natId?: string | null | undefined, taxpayerRep?: number | undefined, certId?: number | undefined, representFrom?: Date | null | undefined, representTo?: Date | null | undefined, ps?: number | undefined, pn?: number | undefined, ordDir?: OrderDirections | undefined): Promise<SearchUserProfileResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateUserContactInfo(userID: number, body?: UpdateUserContactInfoDto | undefined): Promise<UpdateUserContactInfoResponseDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateCurrentUserContactInfo(body?: UpdateCurrentUserProfileRequest | undefined): Promise<number>;
    /**
     * @return Success
     */
    getCurrentUserDetails(): Promise<GetCurrentUserDetailsQueryResponseDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    validateUserOtp(userid: number, otp: string | null, body?: ValidateUserOTPRequest | undefined): Promise<ValidateOTPResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateUserStatus(userid: number, body?: UserStatusUpdateDto | undefined): Promise<UserStatusUpdateResponse>;
    /**
     * @return Success
     */
    getUserDetailsById(userID: number): Promise<GetUserDetailsQueryResponseDto>;
    /**
     * @return Success
     */
    getProfileByCredentialId(credentialID: string | null): Promise<GetUserProfileCredentialResponseDto>;
}

export class TaxpayerManagementPublicClient extends BaseClientApi implements ITaxpayerManagementPublicClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ClientApiConfig, baseUrl?: string, instance?: AxiosInstance) {
        super(configuration);
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : this.getBaseUrl("");
    }

    /**
     * @return Success
     */
    internaltaxpayers(rin: string | null , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/Api/v{version}/internal/internaltaxpayers/{rin}";
        if (rin === undefined || rin === null)
            throw new Error("The parameter 'rin' must be defined.");
        url_ = url_.replace("{rin}", encodeURIComponent("" + rin));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInternaltaxpayers(_response);
        });
    }

    protected processInternaltaxpayers(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validateTaxpayerOtp(rin: string | null, otp: string | null, body?: ValidateTaxpayerOtpRequest | undefined , cancelToken?: CancelToken | undefined): Promise<ValidateTaxpayerOTPResponse> {
        let url_ = this.baseUrl + "/Api/v{version}/taxpayers/{rin}/contactdetails/validation/{otp}";
        if (rin === undefined || rin === null)
            throw new Error("The parameter 'rin' must be defined.");
        url_ = url_.replace("{rin}", encodeURIComponent("" + rin));
        if (otp === undefined || otp === null)
            throw new Error("The parameter 'otp' must be defined.");
        url_ = url_.replace("{otp}", encodeURIComponent("" + otp));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateTaxpayerOtp(_response);
        });
    }

    protected processValidateTaxpayerOtp(response: AxiosResponse): Promise<ValidateTaxpayerOTPResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ValidateTaxpayerOTPResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValidateTaxpayerOTPResponse>(<any>null);
    }

    /**
     * @return Success
     */
    checkDelegationInvitationIsExist(invitationId: string | null , cancelToken?: CancelToken | undefined): Promise<CheckDelegationInvitationValidityQueryResponse> {
        let url_ = this.baseUrl + "/Api/v{version}/taxpayers/delegations/invitations/{invitationId}";
        if (invitationId === undefined || invitationId === null)
            throw new Error("The parameter 'invitationId' must be defined.");
        url_ = url_.replace("{invitationId}", encodeURIComponent("" + invitationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckDelegationInvitationIsExist(_response);
        });
    }

    protected processCheckDelegationInvitationIsExist(response: AxiosResponse): Promise<CheckDelegationInvitationValidityQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CheckDelegationInvitationValidityQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CheckDelegationInvitationValidityQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    registerDelegate(body?: RegisterDelegateDto | undefined , cancelToken?: CancelToken | undefined): Promise<RegisterDelegateResponseDto> {
        let url_ = this.baseUrl + "/Api/v{version}/taxpayers/current/delegates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegisterDelegate(_response);
        });
    }

    protected processRegisterDelegate(response: AxiosResponse): Promise<RegisterDelegateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RegisterDelegateResponseDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegisterDelegateResponseDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateSystemDelegate(body?: UpdateSystemDelegateRequest | undefined , cancelToken?: CancelToken | undefined): Promise<UpdateSystemDelegateResponseDto> {
        let url_ = this.baseUrl + "/Api/v{version}/taxpayers/current/delegates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSystemDelegate(_response);
        });
    }

    protected processUpdateSystemDelegate(response: AxiosResponse): Promise<UpdateSystemDelegateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateSystemDelegateResponseDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateSystemDelegateResponseDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTaxpayerStatus(rin: string | null, body?: TaxpayerStatusUpdateDto | undefined , cancelToken?: CancelToken | undefined): Promise<TaxpayerStatusUpdateResponse> {
        let url_ = this.baseUrl + "/Api/v{version}/taxpayers/{rin}/status";
        if (rin === undefined || rin === null)
            throw new Error("The parameter 'rin' must be defined.");
        url_ = url_.replace("{rin}", encodeURIComponent("" + rin));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateTaxpayerStatus(_response);
        });
    }

    protected processUpdateTaxpayerStatus(response: AxiosResponse): Promise<TaxpayerStatusUpdateResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TaxpayerStatusUpdateResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TaxpayerStatusUpdateResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateDelegateStatus(body?: DelegetesStatusUpdateDto | undefined , cancelToken?: CancelToken | undefined): Promise<DelegetesStatusUpdateResponse> {
        let url_ = this.baseUrl + "/Api/v{version}/taxpayers/current/delegates/status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateDelegateStatus(_response);
        });
    }

    protected processUpdateDelegateStatus(response: AxiosResponse): Promise<DelegetesStatusUpdateResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DelegetesStatusUpdateResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DelegetesStatusUpdateResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createDelegates(rin: string | null, body?: RepresentationInvitationModel | undefined , cancelToken?: CancelToken | undefined): Promise<RegisterDelegateResponseDto> {
        let url_ = this.baseUrl + "/Api/v{version}/taxpayers/{rin}/delegates";
        if (rin === undefined || rin === null)
            throw new Error("The parameter 'rin' must be defined.");
        url_ = url_.replace("{rin}", encodeURIComponent("" + rin));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateDelegates(_response);
        });
    }

    protected processCreateDelegates(response: AxiosResponse): Promise<RegisterDelegateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RegisterDelegateResponseDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegisterDelegateResponseDto>(<any>null);
    }

    /**
     * @param rin (optional) 
     * @param name (optional) 
     * @param bdistrict (optional) 
     * @param bgover (optional) 
     * @param isactive (optional) 
     * @param email (optional) 
     * @param mobileno (optional) 
     * @param type (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param ps (optional) 
     * @param pn (optional) 
     * @return Success
     */
    queryTaxpayers(rin?: string | null | undefined, name?: string | null | undefined, bdistrict?: number | null | undefined, bgover?: number | null | undefined, isactive?: boolean | null | undefined, email?: string | null | undefined, mobileno?: string | null | undefined, type?: string | null | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined, ps?: number | undefined, pn?: number | undefined , cancelToken?: CancelToken | undefined): Promise<GetTaxPayersResponseDto> {
        let url_ = this.baseUrl + "/Api/v{version}/taxpayers?";
        if (rin !== undefined && rin !== null)
            url_ += "rin=" + encodeURIComponent("" + rin) + "&";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (bdistrict !== undefined && bdistrict !== null)
            url_ += "bdistrict=" + encodeURIComponent("" + bdistrict) + "&";
        if (bgover !== undefined && bgover !== null)
            url_ += "bgover=" + encodeURIComponent("" + bgover) + "&";
        if (isactive !== undefined && isactive !== null)
            url_ += "isactive=" + encodeURIComponent("" + isactive) + "&";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (mobileno !== undefined && mobileno !== null)
            url_ += "mobileno=" + encodeURIComponent("" + mobileno) + "&";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (ps === null)
            throw new Error("The parameter 'ps' cannot be null.");
        else if (ps !== undefined)
            url_ += "ps=" + encodeURIComponent("" + ps) + "&";
        if (pn === null)
            throw new Error("The parameter 'pn' cannot be null.");
        else if (pn !== undefined)
            url_ += "pn=" + encodeURIComponent("" + pn) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryTaxpayers(_response);
        });
    }

    protected processQueryTaxpayers(response: AxiosResponse): Promise<GetTaxPayersResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTaxPayersResponseDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTaxPayersResponseDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    acceptInvitation(invitationID: string | null, body?: AccetpInvitationDto | undefined , cancelToken?: CancelToken | undefined): Promise<AcceptDelegationInvitationResponseDto> {
        let url_ = this.baseUrl + "/Api/v{version}/taxpayers/delegations/invitations/{invitationID}";
        if (invitationID === undefined || invitationID === null)
            throw new Error("The parameter 'invitationID' must be defined.");
        url_ = url_.replace("{invitationID}", encodeURIComponent("" + invitationID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAcceptInvitation(_response);
        });
    }

    protected processAcceptInvitation(response: AxiosResponse): Promise<AcceptDelegationInvitationResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AcceptDelegationInvitationResponseDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AcceptDelegationInvitationResponseDto>(<any>null);
    }

    /**
     * @return Success
     */
    getTaxpayerByrin(rin: string | null , cancelToken?: CancelToken | undefined): Promise<GetTaxpayerByRinResponseDto> {
        let url_ = this.baseUrl + "/Api/v{version}/taxpayers/{rin}";
        if (rin === undefined || rin === null)
            throw new Error("The parameter 'rin' must be defined.");
        url_ = url_.replace("{rin}", encodeURIComponent("" + rin));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTaxpayerByrin(_response);
        });
    }

    protected processGetTaxpayerByrin(response: AxiosResponse): Promise<GetTaxpayerByRinResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTaxpayerByRinResponseDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTaxpayerByRinResponseDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    registerTaxpayer(rin: string | null, body?: CreateProfileForTaxpayerRequest | undefined , cancelToken?: CancelToken | undefined): Promise<CreateProfileForExistTaxpayerResponseDto> {
        let url_ = this.baseUrl + "/Api/v{version}/taxpayers/{rin}";
        if (rin === undefined || rin === null)
            throw new Error("The parameter 'rin' must be defined.");
        url_ = url_.replace("{rin}", encodeURIComponent("" + rin));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegisterTaxpayer(_response);
        });
    }

    protected processRegisterTaxpayer(response: AxiosResponse): Promise<CreateProfileForExistTaxpayerResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateProfileForExistTaxpayerResponseDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateProfileForExistTaxpayerResponseDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrentTaxpayerDetails(  cancelToken?: CancelToken | undefined): Promise<GetCurrentTaxpayerResponseDto> {
        let url_ = this.baseUrl + "/Api/v{version}/taxpayers/current";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCurrentTaxpayerDetails(_response);
        });
    }

    protected processGetCurrentTaxpayerDetails(response: AxiosResponse): Promise<GetCurrentTaxpayerResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCurrentTaxpayerResponseDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCurrentTaxpayerResponseDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCompanyDetails(body?: UpdateCompanyProfileRequest | undefined , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/Api/v{version}/taxpayers/current";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCompanyDetails(_response);
        });
    }

    protected processUpdateCompanyDetails(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(<any>null);
    }

    /**
     * @param language (optional) 
     * @return Success
     */
    config(language?: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<GetLookupResponse> {
        let url_ = this.baseUrl + "/Api/v{version}/taxpayers/config?";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConfig(_response);
        });
    }

    protected processConfig(response: AxiosResponse): Promise<GetLookupResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetLookupResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetLookupResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    completeUserProfile(body?: CreateUserProfileDto | undefined , cancelToken?: CancelToken | undefined): Promise<CreateUserProfileResponse> {
        let url_ = this.baseUrl + "/Api/v{version}/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCompleteUserProfile(_response);
        });
    }

    protected processCompleteUserProfile(response: AxiosResponse): Promise<CreateUserProfileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateUserProfileResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateUserProfileResponse>(<any>null);
    }

    /**
     * @param name (optional) 
     * @param status (optional) 
     * @param profType (optional) 
     * @param email (optional) 
     * @param mobileNo (optional) 
     * @param natId (optional) 
     * @param taxpayerRep (optional) 
     * @param certId (optional) 
     * @param representFrom (optional) 
     * @param representTo (optional) 
     * @param ps (optional) 
     * @param pn (optional) 
     * @param ordDir (optional) 
     * @return Success
     */
    queryUsers(name?: string | null | undefined, status?: StatusTypes | undefined, profType?: ProfileTypes | undefined, email?: string | null | undefined, mobileNo?: string | null | undefined, natId?: string | null | undefined, taxpayerRep?: number | undefined, certId?: number | undefined, representFrom?: Date | null | undefined, representTo?: Date | null | undefined, ps?: number | undefined, pn?: number | undefined, ordDir?: OrderDirections | undefined , cancelToken?: CancelToken | undefined): Promise<SearchUserProfileResponse> {
        let url_ = this.baseUrl + "/Api/v{version}/users?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (profType === null)
            throw new Error("The parameter 'profType' cannot be null.");
        else if (profType !== undefined)
            url_ += "ProfType=" + encodeURIComponent("" + profType) + "&";
        if (email !== undefined && email !== null)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        if (mobileNo !== undefined && mobileNo !== null)
            url_ += "MobileNo=" + encodeURIComponent("" + mobileNo) + "&";
        if (natId !== undefined && natId !== null)
            url_ += "NatId=" + encodeURIComponent("" + natId) + "&";
        if (taxpayerRep === null)
            throw new Error("The parameter 'taxpayerRep' cannot be null.");
        else if (taxpayerRep !== undefined)
            url_ += "TaxpayerRep=" + encodeURIComponent("" + taxpayerRep) + "&";
        if (certId === null)
            throw new Error("The parameter 'certId' cannot be null.");
        else if (certId !== undefined)
            url_ += "CertId=" + encodeURIComponent("" + certId) + "&";
        if (representFrom !== undefined && representFrom !== null)
            url_ += "RepresentFrom=" + encodeURIComponent(representFrom ? "" + representFrom.toJSON() : "") + "&";
        if (representTo !== undefined && representTo !== null)
            url_ += "RepresentTo=" + encodeURIComponent(representTo ? "" + representTo.toJSON() : "") + "&";
        if (ps === null)
            throw new Error("The parameter 'ps' cannot be null.");
        else if (ps !== undefined)
            url_ += "Ps=" + encodeURIComponent("" + ps) + "&";
        if (pn === null)
            throw new Error("The parameter 'pn' cannot be null.");
        else if (pn !== undefined)
            url_ += "Pn=" + encodeURIComponent("" + pn) + "&";
        if (ordDir === null)
            throw new Error("The parameter 'ordDir' cannot be null.");
        else if (ordDir !== undefined)
            url_ += "OrdDir=" + encodeURIComponent("" + ordDir) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryUsers(_response);
        });
    }

    protected processQueryUsers(response: AxiosResponse): Promise<SearchUserProfileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SearchUserProfileResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SearchUserProfileResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateUserContactInfo(userID: number, body?: UpdateUserContactInfoDto | undefined , cancelToken?: CancelToken | undefined): Promise<UpdateUserContactInfoResponseDto> {
        let url_ = this.baseUrl + "/Api/v{version}/users/{userID}/contactdetails";
        if (userID === undefined || userID === null)
            throw new Error("The parameter 'userID' must be defined.");
        url_ = url_.replace("{userID}", encodeURIComponent("" + userID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateUserContactInfo(_response);
        });
    }

    protected processUpdateUserContactInfo(response: AxiosResponse): Promise<UpdateUserContactInfoResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateUserContactInfoResponseDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateUserContactInfoResponseDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCurrentUserContactInfo(body?: UpdateCurrentUserProfileRequest | undefined , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/Api/v{version}/users/current";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCurrentUserContactInfo(_response);
        });
    }

    protected processUpdateCurrentUserContactInfo(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrentUserDetails(  cancelToken?: CancelToken | undefined): Promise<GetCurrentUserDetailsQueryResponseDto> {
        let url_ = this.baseUrl + "/Api/v{version}/users/current";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCurrentUserDetails(_response);
        });
    }

    protected processGetCurrentUserDetails(response: AxiosResponse): Promise<GetCurrentUserDetailsQueryResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCurrentUserDetailsQueryResponseDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCurrentUserDetailsQueryResponseDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validateUserOtp(userid: number, otp: string | null, body?: ValidateUserOTPRequest | undefined , cancelToken?: CancelToken | undefined): Promise<ValidateOTPResponse> {
        let url_ = this.baseUrl + "/Api/v{version}/users/{userid}/contactdetails/validation/{otp}";
        if (userid === undefined || userid === null)
            throw new Error("The parameter 'userid' must be defined.");
        url_ = url_.replace("{userid}", encodeURIComponent("" + userid));
        if (otp === undefined || otp === null)
            throw new Error("The parameter 'otp' must be defined.");
        url_ = url_.replace("{otp}", encodeURIComponent("" + otp));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateUserOtp(_response);
        });
    }

    protected processValidateUserOtp(response: AxiosResponse): Promise<ValidateOTPResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ValidateOTPResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValidateOTPResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateUserStatus(userid: number, body?: UserStatusUpdateDto | undefined , cancelToken?: CancelToken | undefined): Promise<UserStatusUpdateResponse> {
        let url_ = this.baseUrl + "/Api/v{version}/users/{userid}/status";
        if (userid === undefined || userid === null)
            throw new Error("The parameter 'userid' must be defined.");
        url_ = url_.replace("{userid}", encodeURIComponent("" + userid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateUserStatus(_response);
        });
    }

    protected processUpdateUserStatus(response: AxiosResponse): Promise<UserStatusUpdateResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserStatusUpdateResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserStatusUpdateResponse>(<any>null);
    }

    /**
     * @return Success
     */
    getUserDetailsById(userID: number , cancelToken?: CancelToken | undefined): Promise<GetUserDetailsQueryResponseDto> {
        let url_ = this.baseUrl + "/Api/v{version}/users/{userID}";
        if (userID === undefined || userID === null)
            throw new Error("The parameter 'userID' must be defined.");
        url_ = url_.replace("{userID}", encodeURIComponent("" + userID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserDetailsById(_response);
        });
    }

    protected processGetUserDetailsById(response: AxiosResponse): Promise<GetUserDetailsQueryResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUserDetailsQueryResponseDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserDetailsQueryResponseDto>(<any>null);
    }

    /**
     * @return Success
     */
    getProfileByCredentialId(credentialID: string | null , cancelToken?: CancelToken | undefined): Promise<GetUserProfileCredentialResponseDto> {
        let url_ = this.baseUrl + "/Api/v{version}/users/credentials/{credentialID}";
        if (credentialID === undefined || credentialID === null)
            throw new Error("The parameter 'credentialID' must be defined.");
        url_ = url_.replace("{credentialID}", encodeURIComponent("" + credentialID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProfileByCredentialId(_response);
        });
    }

    protected processGetProfileByCredentialId(response: AxiosResponse): Promise<GetUserProfileCredentialResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUserProfileCredentialResponseDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserProfileCredentialResponseDto>(<any>null);
    }
}

export enum ValidationType {
    Email = "Email",
    Mobile = "Mobile",
}

export class ValidateTaxpayerOtpRequest implements IValidateTaxpayerOtpRequest {
    validationType?: ValidationType;

    constructor(data?: IValidateTaxpayerOtpRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.validationType = _data["validationType"];
        }
    }

    static fromJS(data: any): ValidateTaxpayerOtpRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateTaxpayerOtpRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validationType"] = this.validationType;
        return data; 
    }

    clone(): ValidateTaxpayerOtpRequest {
        const json = this.toJSON();
        let result = new ValidateTaxpayerOtpRequest();
        result.init(json);
        return result;
    }
}

export interface IValidateTaxpayerOtpRequest {
    validationType?: ValidationType;
}

export class ValidateTaxpayerOTPResponse implements IValidateTaxpayerOTPResponse {
    isSuccess?: boolean;

    constructor(data?: IValidateTaxpayerOTPResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
        }
    }

    static fromJS(data: any): ValidateTaxpayerOTPResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateTaxpayerOTPResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        return data; 
    }

    clone(): ValidateTaxpayerOTPResponse {
        const json = this.toJSON();
        let result = new ValidateTaxpayerOTPResponse();
        result.init(json);
        return result;
    }
}

export interface IValidateTaxpayerOTPResponse {
    isSuccess?: boolean;
}

export class CheckDelegationInvitationValidityQueryResponse implements ICheckDelegationInvitationValidityQueryResponse {
    isValid?: boolean;
    taxpayerNameAr?: string | undefined;
    taxpayerNameEn?: string | undefined;
    nameSecondaryLang?: string | undefined;
    surnameSecondaryLang?: string | undefined;
    namePrimaryLang?: string | undefined;
    surnamePrimaryLang?: string | undefined;
    rin?: string | undefined;
    email?: string | undefined;
    hasAccount?: boolean;
    role?: string | undefined;

    constructor(data?: ICheckDelegationInvitationValidityQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isValid = _data["isValid"];
            this.taxpayerNameAr = _data["taxpayerNameAr"];
            this.taxpayerNameEn = _data["taxpayerNameEn"];
            this.nameSecondaryLang = _data["nameSecondaryLang"];
            this.surnameSecondaryLang = _data["surnameSecondaryLang"];
            this.namePrimaryLang = _data["namePrimaryLang"];
            this.surnamePrimaryLang = _data["surnamePrimaryLang"];
            this.rin = _data["rin"];
            this.email = _data["email"];
            this.hasAccount = _data["hasAccount"];
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): CheckDelegationInvitationValidityQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CheckDelegationInvitationValidityQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isValid"] = this.isValid;
        data["taxpayerNameAr"] = this.taxpayerNameAr;
        data["taxpayerNameEn"] = this.taxpayerNameEn;
        data["nameSecondaryLang"] = this.nameSecondaryLang;
        data["surnameSecondaryLang"] = this.surnameSecondaryLang;
        data["namePrimaryLang"] = this.namePrimaryLang;
        data["surnamePrimaryLang"] = this.surnamePrimaryLang;
        data["rin"] = this.rin;
        data["email"] = this.email;
        data["hasAccount"] = this.hasAccount;
        data["role"] = this.role;
        return data; 
    }

    clone(): CheckDelegationInvitationValidityQueryResponse {
        const json = this.toJSON();
        let result = new CheckDelegationInvitationValidityQueryResponse();
        result.init(json);
        return result;
    }
}

export interface ICheckDelegationInvitationValidityQueryResponse {
    isValid?: boolean;
    taxpayerNameAr?: string | undefined;
    taxpayerNameEn?: string | undefined;
    nameSecondaryLang?: string | undefined;
    surnameSecondaryLang?: string | undefined;
    namePrimaryLang?: string | undefined;
    surnamePrimaryLang?: string | undefined;
    rin?: string | undefined;
    email?: string | undefined;
    hasAccount?: boolean;
    role?: string | undefined;
}

export enum LanguageTypes {
    None = "None",
    En = "En",
    Ar = "Ar",
}

export enum ProfileTypes {
    None = "None",
    User = "User",
    System = "System",
}

export class TaxpayerAccountingSystemDto implements ITaxpayerAccountingSystemDto {
    apiKey?: string | undefined;
    isMainTaxpayerAccountingSystem?: boolean;
    callbackUrl?: string | undefined;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;
    clientSecretExpiryInYears?: number | undefined;

    constructor(data?: ITaxpayerAccountingSystemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.apiKey = _data["apiKey"];
            this.isMainTaxpayerAccountingSystem = _data["isMainTaxpayerAccountingSystem"];
            this.callbackUrl = _data["callbackUrl"];
            this.namePrimaryLang = _data["namePrimaryLang"];
            this.nameSecondaryLang = _data["nameSecondaryLang"];
            this.clientSecretExpiryInYears = _data["clientSecretExpiryInYears"];
        }
    }

    static fromJS(data: any): TaxpayerAccountingSystemDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaxpayerAccountingSystemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apiKey"] = this.apiKey;
        data["isMainTaxpayerAccountingSystem"] = this.isMainTaxpayerAccountingSystem;
        data["callbackUrl"] = this.callbackUrl;
        data["namePrimaryLang"] = this.namePrimaryLang;
        data["nameSecondaryLang"] = this.nameSecondaryLang;
        data["clientSecretExpiryInYears"] = this.clientSecretExpiryInYears;
        return data; 
    }

    clone(): TaxpayerAccountingSystemDto {
        const json = this.toJSON();
        let result = new TaxpayerAccountingSystemDto();
        result.init(json);
        return result;
    }
}

export interface ITaxpayerAccountingSystemDto {
    apiKey?: string | undefined;
    isMainTaxpayerAccountingSystem?: boolean;
    callbackUrl?: string | undefined;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;
    clientSecretExpiryInYears?: number | undefined;
}

export class RepresentationInvitationDto implements IRepresentationInvitationDto {
    email?: string | undefined;
    isAdministrator?: boolean;
    nationalID?: string | undefined;
    dateActivate?: Date | undefined;
    dateDeactivate?: Date | undefined;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;
    surnamePrimaryLang?: string | undefined;
    surnameSecondaryLang?: string | undefined;

    constructor(data?: IRepresentationInvitationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.isAdministrator = _data["isAdministrator"];
            this.nationalID = _data["nationalID"];
            this.dateActivate = _data["dateActivate"] ? new Date(_data["dateActivate"].toString()) : <any>undefined;
            this.dateDeactivate = _data["dateDeactivate"] ? new Date(_data["dateDeactivate"].toString()) : <any>undefined;
            this.namePrimaryLang = _data["namePrimaryLang"];
            this.nameSecondaryLang = _data["nameSecondaryLang"];
            this.surnamePrimaryLang = _data["surnamePrimaryLang"];
            this.surnameSecondaryLang = _data["surnameSecondaryLang"];
        }
    }

    static fromJS(data: any): RepresentationInvitationDto {
        data = typeof data === 'object' ? data : {};
        let result = new RepresentationInvitationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["isAdministrator"] = this.isAdministrator;
        data["nationalID"] = this.nationalID;
        data["dateActivate"] = this.dateActivate ? this.dateActivate.toISOString() : <any>undefined;
        data["dateDeactivate"] = this.dateDeactivate ? this.dateDeactivate.toISOString() : <any>undefined;
        data["namePrimaryLang"] = this.namePrimaryLang;
        data["nameSecondaryLang"] = this.nameSecondaryLang;
        data["surnamePrimaryLang"] = this.surnamePrimaryLang;
        data["surnameSecondaryLang"] = this.surnameSecondaryLang;
        return data; 
    }

    clone(): RepresentationInvitationDto {
        const json = this.toJSON();
        let result = new RepresentationInvitationDto();
        result.init(json);
        return result;
    }
}

export interface IRepresentationInvitationDto {
    email?: string | undefined;
    isAdministrator?: boolean;
    nationalID?: string | undefined;
    dateActivate?: Date | undefined;
    dateDeactivate?: Date | undefined;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;
    surnamePrimaryLang?: string | undefined;
    surnameSecondaryLang?: string | undefined;
}

export class RegisterDelegateDto implements IRegisterDelegateDto {
    preferredLanguage?: LanguageTypes;
    userProfileType?: ProfileTypes;
    taxpayerAccountingSystem?: TaxpayerAccountingSystemDto;
    representationInvitation?: RepresentationInvitationDto;

    constructor(data?: IRegisterDelegateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.preferredLanguage = _data["preferredLanguage"];
            this.userProfileType = _data["userProfileType"];
            this.taxpayerAccountingSystem = _data["taxpayerAccountingSystem"] ? TaxpayerAccountingSystemDto.fromJS(_data["taxpayerAccountingSystem"]) : <any>undefined;
            this.representationInvitation = _data["representationInvitation"] ? RepresentationInvitationDto.fromJS(_data["representationInvitation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RegisterDelegateDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterDelegateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preferredLanguage"] = this.preferredLanguage;
        data["userProfileType"] = this.userProfileType;
        data["taxpayerAccountingSystem"] = this.taxpayerAccountingSystem ? this.taxpayerAccountingSystem.toJSON() : <any>undefined;
        data["representationInvitation"] = this.representationInvitation ? this.representationInvitation.toJSON() : <any>undefined;
        return data; 
    }

    clone(): RegisterDelegateDto {
        const json = this.toJSON();
        let result = new RegisterDelegateDto();
        result.init(json);
        return result;
    }
}

export interface IRegisterDelegateDto {
    preferredLanguage?: LanguageTypes;
    userProfileType?: ProfileTypes;
    taxpayerAccountingSystem?: TaxpayerAccountingSystemDto;
    representationInvitation?: RepresentationInvitationDto;
}

export class ClientSecretDto implements IClientSecretDto {
    clientID?: string | undefined;
    clientSecretOne?: string | undefined;
    clientSecretTow?: string | undefined;

    constructor(data?: IClientSecretDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientID = _data["clientID"];
            this.clientSecretOne = _data["clientSecretOne"];
            this.clientSecretTow = _data["clientSecretTow"];
        }
    }

    static fromJS(data: any): ClientSecretDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientSecretDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientID"] = this.clientID;
        data["clientSecretOne"] = this.clientSecretOne;
        data["clientSecretTow"] = this.clientSecretTow;
        return data; 
    }

    clone(): ClientSecretDto {
        const json = this.toJSON();
        let result = new ClientSecretDto();
        result.init(json);
        return result;
    }
}

export interface IClientSecretDto {
    clientID?: string | undefined;
    clientSecretOne?: string | undefined;
    clientSecretTow?: string | undefined;
}

export class RegisterDelegateResponseDto implements IRegisterDelegateResponseDto {
    clientSecrets?: ClientSecretDto;
    invitationID?: string | undefined;

    constructor(data?: IRegisterDelegateResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientSecrets = _data["clientSecrets"] ? ClientSecretDto.fromJS(_data["clientSecrets"]) : <any>undefined;
            this.invitationID = _data["invitationID"];
        }
    }

    static fromJS(data: any): RegisterDelegateResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterDelegateResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientSecrets"] = this.clientSecrets ? this.clientSecrets.toJSON() : <any>undefined;
        data["invitationID"] = this.invitationID;
        return data; 
    }

    clone(): RegisterDelegateResponseDto {
        const json = this.toJSON();
        let result = new RegisterDelegateResponseDto();
        result.init(json);
        return result;
    }
}

export interface IRegisterDelegateResponseDto {
    clientSecrets?: ClientSecretDto;
    invitationID?: string | undefined;
}

export class UpdateSystemDelegateRequest implements IUpdateSystemDelegateRequest {
    accountingSystemId?: number;
    accountingSystemName?: string | undefined;
    callbackUrl?: string | undefined;
    apiKey?: string | undefined;
    isMainTaxpayerAccountingSystem?: boolean;
    clientSecretExpiryInYears?: number | undefined;

    constructor(data?: IUpdateSystemDelegateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountingSystemId = _data["accountingSystemId"];
            this.accountingSystemName = _data["accountingSystemName"];
            this.callbackUrl = _data["callbackUrl"];
            this.apiKey = _data["apiKey"];
            this.isMainTaxpayerAccountingSystem = _data["isMainTaxpayerAccountingSystem"];
            this.clientSecretExpiryInYears = _data["clientSecretExpiryInYears"];
        }
    }

    static fromJS(data: any): UpdateSystemDelegateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSystemDelegateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountingSystemId"] = this.accountingSystemId;
        data["accountingSystemName"] = this.accountingSystemName;
        data["callbackUrl"] = this.callbackUrl;
        data["apiKey"] = this.apiKey;
        data["isMainTaxpayerAccountingSystem"] = this.isMainTaxpayerAccountingSystem;
        data["clientSecretExpiryInYears"] = this.clientSecretExpiryInYears;
        return data; 
    }

    clone(): UpdateSystemDelegateRequest {
        const json = this.toJSON();
        let result = new UpdateSystemDelegateRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateSystemDelegateRequest {
    accountingSystemId?: number;
    accountingSystemName?: string | undefined;
    callbackUrl?: string | undefined;
    apiKey?: string | undefined;
    isMainTaxpayerAccountingSystem?: boolean;
    clientSecretExpiryInYears?: number | undefined;
}

export class UpdateSystemDelegateResponseDto implements IUpdateSystemDelegateResponseDto {
    clientID?: string | undefined;
    clientSecretOne?: string | undefined;
    clientSecretTow?: string | undefined;
    accountingSystemID?: number;

    constructor(data?: IUpdateSystemDelegateResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientID = _data["clientID"];
            this.clientSecretOne = _data["clientSecretOne"];
            this.clientSecretTow = _data["clientSecretTow"];
            this.accountingSystemID = _data["accountingSystemID"];
        }
    }

    static fromJS(data: any): UpdateSystemDelegateResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSystemDelegateResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientID"] = this.clientID;
        data["clientSecretOne"] = this.clientSecretOne;
        data["clientSecretTow"] = this.clientSecretTow;
        data["accountingSystemID"] = this.accountingSystemID;
        return data; 
    }

    clone(): UpdateSystemDelegateResponseDto {
        const json = this.toJSON();
        let result = new UpdateSystemDelegateResponseDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateSystemDelegateResponseDto {
    clientID?: string | undefined;
    clientSecretOne?: string | undefined;
    clientSecretTow?: string | undefined;
    accountingSystemID?: number;
}

export enum ProfileStatus {
    None = "None",
    Active = "Active",
    Blocked = "Blocked",
}

export class TaxpayerStatusUpdateDto implements ITaxpayerStatusUpdateDto {
    status?: ProfileStatus;
    reason?: string | undefined;

    constructor(data?: ITaxpayerStatusUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): TaxpayerStatusUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaxpayerStatusUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["reason"] = this.reason;
        return data; 
    }

    clone(): TaxpayerStatusUpdateDto {
        const json = this.toJSON();
        let result = new TaxpayerStatusUpdateDto();
        result.init(json);
        return result;
    }
}

export interface ITaxpayerStatusUpdateDto {
    status?: ProfileStatus;
    reason?: string | undefined;
}

export class TaxpayerStatusUpdateResponse implements ITaxpayerStatusUpdateResponse {
    id?: number;

    constructor(data?: ITaxpayerStatusUpdateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TaxpayerStatusUpdateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaxpayerStatusUpdateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }

    clone(): TaxpayerStatusUpdateResponse {
        const json = this.toJSON();
        let result = new TaxpayerStatusUpdateResponse();
        result.init(json);
        return result;
    }
}

export interface ITaxpayerStatusUpdateResponse {
    id?: number;
}

export class DelegeteStatusUpdateDto implements IDelegeteStatusUpdateDto {
    representationID?: number;
    status?: ProfileStatus;
    reason?: string | undefined;
    activeFrom?: Date | undefined;
    activeTo?: Date | undefined;

    constructor(data?: IDelegeteStatusUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.representationID = _data["representationID"];
            this.status = _data["status"];
            this.reason = _data["reason"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DelegeteStatusUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new DelegeteStatusUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["representationID"] = this.representationID;
        data["status"] = this.status;
        data["reason"] = this.reason;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        return data; 
    }

    clone(): DelegeteStatusUpdateDto {
        const json = this.toJSON();
        let result = new DelegeteStatusUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IDelegeteStatusUpdateDto {
    representationID?: number;
    status?: ProfileStatus;
    reason?: string | undefined;
    activeFrom?: Date | undefined;
    activeTo?: Date | undefined;
}

export class DelegetesStatusUpdateDto implements IDelegetesStatusUpdateDto {
    delegeteStatusDto?: DelegeteStatusUpdateDto[] | undefined;

    constructor(data?: IDelegetesStatusUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["delegeteStatusDto"])) {
                this.delegeteStatusDto = [] as any;
                for (let item of _data["delegeteStatusDto"])
                    this.delegeteStatusDto!.push(DelegeteStatusUpdateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DelegetesStatusUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new DelegetesStatusUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.delegeteStatusDto)) {
            data["delegeteStatusDto"] = [];
            for (let item of this.delegeteStatusDto)
                data["delegeteStatusDto"].push(item.toJSON());
        }
        return data; 
    }

    clone(): DelegetesStatusUpdateDto {
        const json = this.toJSON();
        let result = new DelegetesStatusUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IDelegetesStatusUpdateDto {
    delegeteStatusDto?: DelegeteStatusUpdateDto[] | undefined;
}

export class DelegetesStatusUpdateResponse implements IDelegetesStatusUpdateResponse {
    isSuccess?: boolean;

    constructor(data?: IDelegetesStatusUpdateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
        }
    }

    static fromJS(data: any): DelegetesStatusUpdateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DelegetesStatusUpdateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        return data; 
    }

    clone(): DelegetesStatusUpdateResponse {
        const json = this.toJSON();
        let result = new DelegetesStatusUpdateResponse();
        result.init(json);
        return result;
    }
}

export interface IDelegetesStatusUpdateResponse {
    isSuccess?: boolean;
}

export class RepresentationInvitationModel implements IRepresentationInvitationModel {
    preferredLanguage?: LanguageTypes;
    userProfileType?: ProfileTypes;
    registrationNumber?: string | undefined;
    taxpayerAccountingSystem?: TaxpayerAccountingSystemDto;
    representationInvitation?: RepresentationInvitationDto;

    constructor(data?: IRepresentationInvitationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.preferredLanguage = _data["preferredLanguage"];
            this.userProfileType = _data["userProfileType"];
            this.registrationNumber = _data["registrationNumber"];
            this.taxpayerAccountingSystem = _data["taxpayerAccountingSystem"] ? TaxpayerAccountingSystemDto.fromJS(_data["taxpayerAccountingSystem"]) : <any>undefined;
            this.representationInvitation = _data["representationInvitation"] ? RepresentationInvitationDto.fromJS(_data["representationInvitation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RepresentationInvitationModel {
        data = typeof data === 'object' ? data : {};
        let result = new RepresentationInvitationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preferredLanguage"] = this.preferredLanguage;
        data["userProfileType"] = this.userProfileType;
        data["registrationNumber"] = this.registrationNumber;
        data["taxpayerAccountingSystem"] = this.taxpayerAccountingSystem ? this.taxpayerAccountingSystem.toJSON() : <any>undefined;
        data["representationInvitation"] = this.representationInvitation ? this.representationInvitation.toJSON() : <any>undefined;
        return data; 
    }

    clone(): RepresentationInvitationModel {
        const json = this.toJSON();
        let result = new RepresentationInvitationModel();
        result.init(json);
        return result;
    }
}

export interface IRepresentationInvitationModel {
    preferredLanguage?: LanguageTypes;
    userProfileType?: ProfileTypes;
    registrationNumber?: string | undefined;
    taxpayerAccountingSystem?: TaxpayerAccountingSystemDto;
    representationInvitation?: RepresentationInvitationDto;
}

export class GetTaxPayerResponseDto implements IGetTaxPayerResponseDto {
    taxpayerID?: number;
    registrationNumber?: string | undefined;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;
    taxpayerStatusName?: string | undefined;
    isActive?: boolean;
    operationStartDate?: Date;
    operationEndDate?: Date | undefined;
    establishmentDate?: Date | undefined;
    governorateName?: string | undefined;

    constructor(data?: IGetTaxPayerResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxpayerID = _data["taxpayerID"];
            this.registrationNumber = _data["registrationNumber"];
            this.namePrimaryLang = _data["namePrimaryLang"];
            this.nameSecondaryLang = _data["nameSecondaryLang"];
            this.taxpayerStatusName = _data["taxpayerStatusName"];
            this.isActive = _data["isActive"];
            this.operationStartDate = _data["operationStartDate"] ? new Date(_data["operationStartDate"].toString()) : <any>undefined;
            this.operationEndDate = _data["operationEndDate"] ? new Date(_data["operationEndDate"].toString()) : <any>undefined;
            this.establishmentDate = _data["establishmentDate"] ? new Date(_data["establishmentDate"].toString()) : <any>undefined;
            this.governorateName = _data["governorateName"];
        }
    }

    static fromJS(data: any): GetTaxPayerResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTaxPayerResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxpayerID"] = this.taxpayerID;
        data["registrationNumber"] = this.registrationNumber;
        data["namePrimaryLang"] = this.namePrimaryLang;
        data["nameSecondaryLang"] = this.nameSecondaryLang;
        data["taxpayerStatusName"] = this.taxpayerStatusName;
        data["isActive"] = this.isActive;
        data["operationStartDate"] = this.operationStartDate ? this.operationStartDate.toISOString() : <any>undefined;
        data["operationEndDate"] = this.operationEndDate ? this.operationEndDate.toISOString() : <any>undefined;
        data["establishmentDate"] = this.establishmentDate ? this.establishmentDate.toISOString() : <any>undefined;
        data["governorateName"] = this.governorateName;
        return data; 
    }

    clone(): GetTaxPayerResponseDto {
        const json = this.toJSON();
        let result = new GetTaxPayerResponseDto();
        result.init(json);
        return result;
    }
}

export interface IGetTaxPayerResponseDto {
    taxpayerID?: number;
    registrationNumber?: string | undefined;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;
    taxpayerStatusName?: string | undefined;
    isActive?: boolean;
    operationStartDate?: Date;
    operationEndDate?: Date | undefined;
    establishmentDate?: Date | undefined;
    governorateName?: string | undefined;
}

export class MetaDataDto implements IMetaDataDto {
    totalPages?: number;
    totalCount?: number;

    constructor(data?: IMetaDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MetaDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new MetaDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        return data; 
    }

    clone(): MetaDataDto {
        const json = this.toJSON();
        let result = new MetaDataDto();
        result.init(json);
        return result;
    }
}

export interface IMetaDataDto {
    totalPages?: number;
    totalCount?: number;
}

export class GetTaxPayersResponseDto implements IGetTaxPayersResponseDto {
    result?: GetTaxPayerResponseDto[] | undefined;
    metadata?: MetaDataDto;

    constructor(data?: IGetTaxPayersResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(GetTaxPayerResponseDto.fromJS(item));
            }
            this.metadata = _data["metadata"] ? MetaDataDto.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTaxPayersResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTaxPayersResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        return data; 
    }

    clone(): GetTaxPayersResponseDto {
        const json = this.toJSON();
        let result = new GetTaxPayersResponseDto();
        result.init(json);
        return result;
    }
}

export interface IGetTaxPayersResponseDto {
    result?: GetTaxPayerResponseDto[] | undefined;
    metadata?: MetaDataDto;
}

export class AccetpInvitationDto implements IAccetpInvitationDto {
    nationalID?: string | undefined;

    constructor(data?: IAccetpInvitationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nationalID = _data["nationalID"];
        }
    }

    static fromJS(data: any): AccetpInvitationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccetpInvitationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nationalID"] = this.nationalID;
        return data; 
    }

    clone(): AccetpInvitationDto {
        const json = this.toJSON();
        let result = new AccetpInvitationDto();
        result.init(json);
        return result;
    }
}

export interface IAccetpInvitationDto {
    nationalID?: string | undefined;
}

export class AcceptDelegationInvitationResponseDto implements IAcceptDelegationInvitationResponseDto {
    isSuccess?: boolean | undefined;
    representationId?: number | undefined;

    constructor(data?: IAcceptDelegationInvitationResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.representationId = _data["representationId"];
        }
    }

    static fromJS(data: any): AcceptDelegationInvitationResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptDelegationInvitationResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["representationId"] = this.representationId;
        return data; 
    }

    clone(): AcceptDelegationInvitationResponseDto {
        const json = this.toJSON();
        let result = new AcceptDelegationInvitationResponseDto();
        result.init(json);
        return result;
    }
}

export interface IAcceptDelegationInvitationResponseDto {
    isSuccess?: boolean | undefined;
    representationId?: number | undefined;
}

export class GetTaxpayerAddressDto implements IGetTaxpayerAddressDto {
    id?: number;
    streetName?: string | undefined;
    buildingNo?: string | undefined;
    cityNamePrimaryLang?: string | undefined;
    cityNameSecondaryLang?: string | undefined;
    countryNamePrimaryLang?: string | undefined;
    countryNameSecondaryLang?: string | undefined;
    governorateNamePrimaryLang?: string | undefined;
    governorateNameSecondaryLang?: string | undefined;
    flatNo?: string | undefined;
    cityID?: number;
    countryID?: number;
    countryCode?: string | undefined;
    governorateID?: number;
    floorNo?: string | undefined;
    streetName2?: string | undefined;
    additionalInformation?: string | undefined;
    postalCode?: string | undefined;
    foreignGovernorateName?: string | undefined;
    foreignCityName?: string | undefined;
    readonly formattedAddressAr?: string | undefined;
    readonly formattedAddressEn?: string | undefined;

    constructor(data?: IGetTaxpayerAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.streetName = _data["streetName"];
            this.buildingNo = _data["buildingNo"];
            this.cityNamePrimaryLang = _data["cityNamePrimaryLang"];
            this.cityNameSecondaryLang = _data["cityNameSecondaryLang"];
            this.countryNamePrimaryLang = _data["countryNamePrimaryLang"];
            this.countryNameSecondaryLang = _data["countryNameSecondaryLang"];
            this.governorateNamePrimaryLang = _data["governorateNamePrimaryLang"];
            this.governorateNameSecondaryLang = _data["governorateNameSecondaryLang"];
            this.flatNo = _data["flatNo"];
            this.cityID = _data["cityID"];
            this.countryID = _data["countryID"];
            this.countryCode = _data["countryCode"];
            this.governorateID = _data["governorateID"];
            this.floorNo = _data["floorNo"];
            this.streetName2 = _data["streetName2"];
            this.additionalInformation = _data["additionalInformation"];
            this.postalCode = _data["postalCode"];
            this.foreignGovernorateName = _data["foreignGovernorateName"];
            this.foreignCityName = _data["foreignCityName"];
            (<any>this).formattedAddressAr = _data["formattedAddressAr"];
            (<any>this).formattedAddressEn = _data["formattedAddressEn"];
        }
    }

    static fromJS(data: any): GetTaxpayerAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTaxpayerAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["streetName"] = this.streetName;
        data["buildingNo"] = this.buildingNo;
        data["cityNamePrimaryLang"] = this.cityNamePrimaryLang;
        data["cityNameSecondaryLang"] = this.cityNameSecondaryLang;
        data["countryNamePrimaryLang"] = this.countryNamePrimaryLang;
        data["countryNameSecondaryLang"] = this.countryNameSecondaryLang;
        data["governorateNamePrimaryLang"] = this.governorateNamePrimaryLang;
        data["governorateNameSecondaryLang"] = this.governorateNameSecondaryLang;
        data["flatNo"] = this.flatNo;
        data["cityID"] = this.cityID;
        data["countryID"] = this.countryID;
        data["countryCode"] = this.countryCode;
        data["governorateID"] = this.governorateID;
        data["floorNo"] = this.floorNo;
        data["streetName2"] = this.streetName2;
        data["additionalInformation"] = this.additionalInformation;
        data["postalCode"] = this.postalCode;
        data["foreignGovernorateName"] = this.foreignGovernorateName;
        data["foreignCityName"] = this.foreignCityName;
        data["formattedAddressAr"] = this.formattedAddressAr;
        data["formattedAddressEn"] = this.formattedAddressEn;
        return data; 
    }

    clone(): GetTaxpayerAddressDto {
        const json = this.toJSON();
        let result = new GetTaxpayerAddressDto();
        result.init(json);
        return result;
    }
}

export interface IGetTaxpayerAddressDto {
    id?: number;
    streetName?: string | undefined;
    buildingNo?: string | undefined;
    cityNamePrimaryLang?: string | undefined;
    cityNameSecondaryLang?: string | undefined;
    countryNamePrimaryLang?: string | undefined;
    countryNameSecondaryLang?: string | undefined;
    governorateNamePrimaryLang?: string | undefined;
    governorateNameSecondaryLang?: string | undefined;
    flatNo?: string | undefined;
    cityID?: number;
    countryID?: number;
    countryCode?: string | undefined;
    governorateID?: number;
    floorNo?: string | undefined;
    streetName2?: string | undefined;
    additionalInformation?: string | undefined;
    postalCode?: string | undefined;
    foreignGovernorateName?: string | undefined;
    foreignCityName?: string | undefined;
    formattedAddressAr?: string | undefined;
    formattedAddressEn?: string | undefined;
}

export class GetTaxpayerBranchDto implements IGetTaxpayerBranchDto {
    branchID?: number;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;
    taxDistrictNamePrimaryLang?: string | undefined;
    taxDistrictNameSecondaryLang?: string | undefined;
    isMainBranch?: boolean;
    sourceAddress?: string | undefined;
    sourcePhoneNumber?: string | undefined;
    sourceBranchID?: string | undefined;
    address?: GetTaxpayerAddressDto;

    constructor(data?: IGetTaxpayerBranchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branchID = _data["branchID"];
            this.namePrimaryLang = _data["namePrimaryLang"];
            this.nameSecondaryLang = _data["nameSecondaryLang"];
            this.taxDistrictNamePrimaryLang = _data["taxDistrictNamePrimaryLang"];
            this.taxDistrictNameSecondaryLang = _data["taxDistrictNameSecondaryLang"];
            this.isMainBranch = _data["isMainBranch"];
            this.sourceAddress = _data["sourceAddress"];
            this.sourcePhoneNumber = _data["sourcePhoneNumber"];
            this.sourceBranchID = _data["sourceBranchID"];
            this.address = _data["address"] ? GetTaxpayerAddressDto.fromJS(_data["address"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTaxpayerBranchDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTaxpayerBranchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchID"] = this.branchID;
        data["namePrimaryLang"] = this.namePrimaryLang;
        data["nameSecondaryLang"] = this.nameSecondaryLang;
        data["taxDistrictNamePrimaryLang"] = this.taxDistrictNamePrimaryLang;
        data["taxDistrictNameSecondaryLang"] = this.taxDistrictNameSecondaryLang;
        data["isMainBranch"] = this.isMainBranch;
        data["sourceAddress"] = this.sourceAddress;
        data["sourcePhoneNumber"] = this.sourcePhoneNumber;
        data["sourceBranchID"] = this.sourceBranchID;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        return data; 
    }

    clone(): GetTaxpayerBranchDto {
        const json = this.toJSON();
        let result = new GetTaxpayerBranchDto();
        result.init(json);
        return result;
    }
}

export interface IGetTaxpayerBranchDto {
    branchID?: number;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;
    taxDistrictNamePrimaryLang?: string | undefined;
    taxDistrictNameSecondaryLang?: string | undefined;
    isMainBranch?: boolean;
    sourceAddress?: string | undefined;
    sourcePhoneNumber?: string | undefined;
    sourceBranchID?: string | undefined;
    address?: GetTaxpayerAddressDto;
}

export enum StatusTypes {
    Active = "Active",
    Blocked = "Blocked",
    Pending = "Pending",
    Complete = "Complete",
    Expired = "Expired",
}

export class GetRepresentationOfTaxpayerDto implements IGetRepresentationOfTaxpayerDto {
    taxpayerRepresentationID?: number;
    dateActivated?: Date;
    dateDeactivated?: Date | undefined;
    isAdministrator?: boolean;
    dateCreated?: Date;
    dateBlocked?: Date | undefined;
    userProfileID?: number;
    profileNamePrimaryLang?: string | undefined;
    profileNameSecondaryLang?: string | undefined;
    status?: StatusTypes;
    preferredLanguage?: LanguageTypes;
    userProfileType?: ProfileTypes;
    userProfileStatus?: StatusTypes;
    email?: string | undefined;
    clientID?: string | undefined;
    clientValidTo?: Date | undefined;
    callbackUrl?: string | undefined;
    apiKey?: string | undefined;
    isMainTaxpayerAccountingSystem?: boolean;

    constructor(data?: IGetRepresentationOfTaxpayerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxpayerRepresentationID = _data["taxpayerRepresentationID"];
            this.dateActivated = _data["dateActivated"] ? new Date(_data["dateActivated"].toString()) : <any>undefined;
            this.dateDeactivated = _data["dateDeactivated"] ? new Date(_data["dateDeactivated"].toString()) : <any>undefined;
            this.isAdministrator = _data["isAdministrator"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : <any>undefined;
            this.dateBlocked = _data["dateBlocked"] ? new Date(_data["dateBlocked"].toString()) : <any>undefined;
            this.userProfileID = _data["userProfileID"];
            this.profileNamePrimaryLang = _data["profileNamePrimaryLang"];
            this.profileNameSecondaryLang = _data["profileNameSecondaryLang"];
            this.status = _data["status"];
            this.preferredLanguage = _data["preferredLanguage"];
            this.userProfileType = _data["userProfileType"];
            this.userProfileStatus = _data["userProfileStatus"];
            this.email = _data["email"];
            this.clientID = _data["clientID"];
            this.clientValidTo = _data["clientValidTo"] ? new Date(_data["clientValidTo"].toString()) : <any>undefined;
            this.callbackUrl = _data["callbackUrl"];
            this.apiKey = _data["apiKey"];
            this.isMainTaxpayerAccountingSystem = _data["isMainTaxpayerAccountingSystem"];
        }
    }

    static fromJS(data: any): GetRepresentationOfTaxpayerDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetRepresentationOfTaxpayerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxpayerRepresentationID"] = this.taxpayerRepresentationID;
        data["dateActivated"] = this.dateActivated ? this.dateActivated.toISOString() : <any>undefined;
        data["dateDeactivated"] = this.dateDeactivated ? this.dateDeactivated.toISOString() : <any>undefined;
        data["isAdministrator"] = this.isAdministrator;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data["dateBlocked"] = this.dateBlocked ? this.dateBlocked.toISOString() : <any>undefined;
        data["userProfileID"] = this.userProfileID;
        data["profileNamePrimaryLang"] = this.profileNamePrimaryLang;
        data["profileNameSecondaryLang"] = this.profileNameSecondaryLang;
        data["status"] = this.status;
        data["preferredLanguage"] = this.preferredLanguage;
        data["userProfileType"] = this.userProfileType;
        data["userProfileStatus"] = this.userProfileStatus;
        data["email"] = this.email;
        data["clientID"] = this.clientID;
        data["clientValidTo"] = this.clientValidTo ? this.clientValidTo.toISOString() : <any>undefined;
        data["callbackUrl"] = this.callbackUrl;
        data["apiKey"] = this.apiKey;
        data["isMainTaxpayerAccountingSystem"] = this.isMainTaxpayerAccountingSystem;
        return data; 
    }

    clone(): GetRepresentationOfTaxpayerDto {
        const json = this.toJSON();
        let result = new GetRepresentationOfTaxpayerDto();
        result.init(json);
        return result;
    }
}

export interface IGetRepresentationOfTaxpayerDto {
    taxpayerRepresentationID?: number;
    dateActivated?: Date;
    dateDeactivated?: Date | undefined;
    isAdministrator?: boolean;
    dateCreated?: Date;
    dateBlocked?: Date | undefined;
    userProfileID?: number;
    profileNamePrimaryLang?: string | undefined;
    profileNameSecondaryLang?: string | undefined;
    status?: StatusTypes;
    preferredLanguage?: LanguageTypes;
    userProfileType?: ProfileTypes;
    userProfileStatus?: StatusTypes;
    email?: string | undefined;
    clientID?: string | undefined;
    clientValidTo?: Date | undefined;
    callbackUrl?: string | undefined;
    apiKey?: string | undefined;
    isMainTaxpayerAccountingSystem?: boolean;
}

export class GetTaxpayerByRinResponseDto implements IGetTaxpayerByRinResponseDto {
    id?: number;
    registrationNumber?: string | undefined;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;
    taxpayerTypeName?: string | undefined;
    taxpayerStatusName?: string | undefined;
    operationStartDate?: Date;
    operationEndDate?: Date | undefined;
    establishmentDate?: Date | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    mobileNo?: string | undefined;
    address?: string | undefined;
    language?: LanguageTypes;
    businessTradeName?: string | undefined;
    taxDistrictName?: string | undefined;
    isActive?: boolean;
    isVATEnabled?: boolean;
    taxPayerAddress?: GetTaxpayerAddressDto;
    taxpayerBranchs?: GetTaxpayerBranchDto[] | undefined;
    taxpayersRepresentation?: GetRepresentationOfTaxpayerDto[] | undefined;

    constructor(data?: IGetTaxpayerByRinResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.registrationNumber = _data["registrationNumber"];
            this.namePrimaryLang = _data["namePrimaryLang"];
            this.nameSecondaryLang = _data["nameSecondaryLang"];
            this.taxpayerTypeName = _data["taxpayerTypeName"];
            this.taxpayerStatusName = _data["taxpayerStatusName"];
            this.operationStartDate = _data["operationStartDate"] ? new Date(_data["operationStartDate"].toString()) : <any>undefined;
            this.operationEndDate = _data["operationEndDate"] ? new Date(_data["operationEndDate"].toString()) : <any>undefined;
            this.establishmentDate = _data["establishmentDate"] ? new Date(_data["establishmentDate"].toString()) : <any>undefined;
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.mobileNo = _data["mobileNo"];
            this.address = _data["address"];
            this.language = _data["language"];
            this.businessTradeName = _data["businessTradeName"];
            this.taxDistrictName = _data["taxDistrictName"];
            this.isActive = _data["isActive"];
            this.isVATEnabled = _data["isVATEnabled"];
            this.taxPayerAddress = _data["taxPayerAddress"] ? GetTaxpayerAddressDto.fromJS(_data["taxPayerAddress"]) : <any>undefined;
            if (Array.isArray(_data["taxpayerBranchs"])) {
                this.taxpayerBranchs = [] as any;
                for (let item of _data["taxpayerBranchs"])
                    this.taxpayerBranchs!.push(GetTaxpayerBranchDto.fromJS(item));
            }
            if (Array.isArray(_data["taxpayersRepresentation"])) {
                this.taxpayersRepresentation = [] as any;
                for (let item of _data["taxpayersRepresentation"])
                    this.taxpayersRepresentation!.push(GetRepresentationOfTaxpayerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTaxpayerByRinResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTaxpayerByRinResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["registrationNumber"] = this.registrationNumber;
        data["namePrimaryLang"] = this.namePrimaryLang;
        data["nameSecondaryLang"] = this.nameSecondaryLang;
        data["taxpayerTypeName"] = this.taxpayerTypeName;
        data["taxpayerStatusName"] = this.taxpayerStatusName;
        data["operationStartDate"] = this.operationStartDate ? this.operationStartDate.toISOString() : <any>undefined;
        data["operationEndDate"] = this.operationEndDate ? this.operationEndDate.toISOString() : <any>undefined;
        data["establishmentDate"] = this.establishmentDate ? this.establishmentDate.toISOString() : <any>undefined;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["mobileNo"] = this.mobileNo;
        data["address"] = this.address;
        data["language"] = this.language;
        data["businessTradeName"] = this.businessTradeName;
        data["taxDistrictName"] = this.taxDistrictName;
        data["isActive"] = this.isActive;
        data["isVATEnabled"] = this.isVATEnabled;
        data["taxPayerAddress"] = this.taxPayerAddress ? this.taxPayerAddress.toJSON() : <any>undefined;
        if (Array.isArray(this.taxpayerBranchs)) {
            data["taxpayerBranchs"] = [];
            for (let item of this.taxpayerBranchs)
                data["taxpayerBranchs"].push(item.toJSON());
        }
        if (Array.isArray(this.taxpayersRepresentation)) {
            data["taxpayersRepresentation"] = [];
            for (let item of this.taxpayersRepresentation)
                data["taxpayersRepresentation"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetTaxpayerByRinResponseDto {
        const json = this.toJSON();
        let result = new GetTaxpayerByRinResponseDto();
        result.init(json);
        return result;
    }
}

export interface IGetTaxpayerByRinResponseDto {
    id?: number;
    registrationNumber?: string | undefined;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;
    taxpayerTypeName?: string | undefined;
    taxpayerStatusName?: string | undefined;
    operationStartDate?: Date;
    operationEndDate?: Date | undefined;
    establishmentDate?: Date | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    mobileNo?: string | undefined;
    address?: string | undefined;
    language?: LanguageTypes;
    businessTradeName?: string | undefined;
    taxDistrictName?: string | undefined;
    isActive?: boolean;
    isVATEnabled?: boolean;
    taxPayerAddress?: GetTaxpayerAddressDto;
    taxpayerBranchs?: GetTaxpayerBranchDto[] | undefined;
    taxpayersRepresentation?: GetRepresentationOfTaxpayerDto[] | undefined;
}

export class TaxpayerProfileBranchAddressReqDto implements ITaxpayerProfileBranchAddressReqDto {
    streetName?: string | undefined;
    flatNo?: string | undefined;
    buildingNo?: string | undefined;
    cityID?: number | undefined;
    countryID?: number;
    countryCode?: string | undefined;
    governorateID?: number | undefined;
    floorNo?: string | undefined;
    additionalInformation?: string | undefined;
    postalCode?: string | undefined;
    streetName2?: string | undefined;
    foreignGovernorateName?: string | undefined;
    foreignCityName?: string | undefined;

    constructor(data?: ITaxpayerProfileBranchAddressReqDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.streetName = _data["streetName"];
            this.flatNo = _data["flatNo"];
            this.buildingNo = _data["buildingNo"];
            this.cityID = _data["cityID"];
            this.countryID = _data["countryID"];
            this.countryCode = _data["countryCode"];
            this.governorateID = _data["governorateID"];
            this.floorNo = _data["floorNo"];
            this.additionalInformation = _data["additionalInformation"];
            this.postalCode = _data["postalCode"];
            this.streetName2 = _data["streetName2"];
            this.foreignGovernorateName = _data["foreignGovernorateName"];
            this.foreignCityName = _data["foreignCityName"];
        }
    }

    static fromJS(data: any): TaxpayerProfileBranchAddressReqDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaxpayerProfileBranchAddressReqDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["streetName"] = this.streetName;
        data["flatNo"] = this.flatNo;
        data["buildingNo"] = this.buildingNo;
        data["cityID"] = this.cityID;
        data["countryID"] = this.countryID;
        data["countryCode"] = this.countryCode;
        data["governorateID"] = this.governorateID;
        data["floorNo"] = this.floorNo;
        data["additionalInformation"] = this.additionalInformation;
        data["postalCode"] = this.postalCode;
        data["streetName2"] = this.streetName2;
        data["foreignGovernorateName"] = this.foreignGovernorateName;
        data["foreignCityName"] = this.foreignCityName;
        return data; 
    }

    clone(): TaxpayerProfileBranchAddressReqDto {
        const json = this.toJSON();
        let result = new TaxpayerProfileBranchAddressReqDto();
        result.init(json);
        return result;
    }
}

export interface ITaxpayerProfileBranchAddressReqDto {
    streetName?: string | undefined;
    flatNo?: string | undefined;
    buildingNo?: string | undefined;
    cityID?: number | undefined;
    countryID?: number;
    countryCode?: string | undefined;
    governorateID?: number | undefined;
    floorNo?: string | undefined;
    additionalInformation?: string | undefined;
    postalCode?: string | undefined;
    streetName2?: string | undefined;
    foreignGovernorateName?: string | undefined;
    foreignCityName?: string | undefined;
}

export class TaxpayerProfileBranchRequestDto implements ITaxpayerProfileBranchRequestDto {
    branchID?: number;
    branchName?: string | undefined;
    address?: TaxpayerProfileBranchAddressReqDto;

    constructor(data?: ITaxpayerProfileBranchRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branchID = _data["branchID"];
            this.branchName = _data["branchName"];
            this.address = _data["address"] ? TaxpayerProfileBranchAddressReqDto.fromJS(_data["address"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TaxpayerProfileBranchRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaxpayerProfileBranchRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchID"] = this.branchID;
        data["branchName"] = this.branchName;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        return data; 
    }

    clone(): TaxpayerProfileBranchRequestDto {
        const json = this.toJSON();
        let result = new TaxpayerProfileBranchRequestDto();
        result.init(json);
        return result;
    }
}

export interface ITaxpayerProfileBranchRequestDto {
    branchID?: number;
    branchName?: string | undefined;
    address?: TaxpayerProfileBranchAddressReqDto;
}

export class CreateProfileForTaxpayerRequest implements ICreateProfileForTaxpayerRequest {
    namePrimaryLang?: string | undefined;
    email?: string | undefined;
    mobileNo?: string | undefined;
    preferredLanguage?: LanguageTypes;
    isActive?: boolean;
    taxpayerBranchs?: TaxpayerProfileBranchRequestDto[] | undefined;

    constructor(data?: ICreateProfileForTaxpayerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.namePrimaryLang = _data["namePrimaryLang"];
            this.email = _data["email"];
            this.mobileNo = _data["mobileNo"];
            this.preferredLanguage = _data["preferredLanguage"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["taxpayerBranchs"])) {
                this.taxpayerBranchs = [] as any;
                for (let item of _data["taxpayerBranchs"])
                    this.taxpayerBranchs!.push(TaxpayerProfileBranchRequestDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateProfileForTaxpayerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProfileForTaxpayerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["namePrimaryLang"] = this.namePrimaryLang;
        data["email"] = this.email;
        data["mobileNo"] = this.mobileNo;
        data["preferredLanguage"] = this.preferredLanguage;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.taxpayerBranchs)) {
            data["taxpayerBranchs"] = [];
            for (let item of this.taxpayerBranchs)
                data["taxpayerBranchs"].push(item.toJSON());
        }
        return data; 
    }

    clone(): CreateProfileForTaxpayerRequest {
        const json = this.toJSON();
        let result = new CreateProfileForTaxpayerRequest();
        result.init(json);
        return result;
    }
}

export interface ICreateProfileForTaxpayerRequest {
    namePrimaryLang?: string | undefined;
    email?: string | undefined;
    mobileNo?: string | undefined;
    preferredLanguage?: LanguageTypes;
    isActive?: boolean;
    taxpayerBranchs?: TaxpayerProfileBranchRequestDto[] | undefined;
}

export class TaxpayerProfileBranchResponse implements ITaxpayerProfileBranchResponse {
    branchID?: number;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;
    taxDistrictNamePrimaryLang?: string | undefined;
    taxDistrictNameSecondaryLang?: string | undefined;
    isMainBranch?: boolean;
    branchStartDate?: Date;
    branchCeaseDate?: Date | undefined;
    branchCertPrintDate?: Date | undefined;
    streetName?: string | undefined;
    flatNo?: string | undefined;
    buildingNo?: string | undefined;
    cityNamePrimaryLang?: string | undefined;
    cityNameSecondaryLang?: string | undefined;
    sourceBranchID?: string | undefined;
    sourceAddress?: string | undefined;
    sourcePhoneNumber?: string | undefined;

    constructor(data?: ITaxpayerProfileBranchResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branchID = _data["branchID"];
            this.namePrimaryLang = _data["namePrimaryLang"];
            this.nameSecondaryLang = _data["nameSecondaryLang"];
            this.taxDistrictNamePrimaryLang = _data["taxDistrictNamePrimaryLang"];
            this.taxDistrictNameSecondaryLang = _data["taxDistrictNameSecondaryLang"];
            this.isMainBranch = _data["isMainBranch"];
            this.branchStartDate = _data["branchStartDate"] ? new Date(_data["branchStartDate"].toString()) : <any>undefined;
            this.branchCeaseDate = _data["branchCeaseDate"] ? new Date(_data["branchCeaseDate"].toString()) : <any>undefined;
            this.branchCertPrintDate = _data["branchCertPrintDate"] ? new Date(_data["branchCertPrintDate"].toString()) : <any>undefined;
            this.streetName = _data["streetName"];
            this.flatNo = _data["flatNo"];
            this.buildingNo = _data["buildingNo"];
            this.cityNamePrimaryLang = _data["cityNamePrimaryLang"];
            this.cityNameSecondaryLang = _data["cityNameSecondaryLang"];
            this.sourceBranchID = _data["sourceBranchID"];
            this.sourceAddress = _data["sourceAddress"];
            this.sourcePhoneNumber = _data["sourcePhoneNumber"];
        }
    }

    static fromJS(data: any): TaxpayerProfileBranchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaxpayerProfileBranchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchID"] = this.branchID;
        data["namePrimaryLang"] = this.namePrimaryLang;
        data["nameSecondaryLang"] = this.nameSecondaryLang;
        data["taxDistrictNamePrimaryLang"] = this.taxDistrictNamePrimaryLang;
        data["taxDistrictNameSecondaryLang"] = this.taxDistrictNameSecondaryLang;
        data["isMainBranch"] = this.isMainBranch;
        data["branchStartDate"] = this.branchStartDate ? this.branchStartDate.toISOString() : <any>undefined;
        data["branchCeaseDate"] = this.branchCeaseDate ? this.branchCeaseDate.toISOString() : <any>undefined;
        data["branchCertPrintDate"] = this.branchCertPrintDate ? this.branchCertPrintDate.toISOString() : <any>undefined;
        data["streetName"] = this.streetName;
        data["flatNo"] = this.flatNo;
        data["buildingNo"] = this.buildingNo;
        data["cityNamePrimaryLang"] = this.cityNamePrimaryLang;
        data["cityNameSecondaryLang"] = this.cityNameSecondaryLang;
        data["sourceBranchID"] = this.sourceBranchID;
        data["sourceAddress"] = this.sourceAddress;
        data["sourcePhoneNumber"] = this.sourcePhoneNumber;
        return data; 
    }

    clone(): TaxpayerProfileBranchResponse {
        const json = this.toJSON();
        let result = new TaxpayerProfileBranchResponse();
        result.init(json);
        return result;
    }
}

export interface ITaxpayerProfileBranchResponse {
    branchID?: number;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;
    taxDistrictNamePrimaryLang?: string | undefined;
    taxDistrictNameSecondaryLang?: string | undefined;
    isMainBranch?: boolean;
    branchStartDate?: Date;
    branchCeaseDate?: Date | undefined;
    branchCertPrintDate?: Date | undefined;
    streetName?: string | undefined;
    flatNo?: string | undefined;
    buildingNo?: string | undefined;
    cityNamePrimaryLang?: string | undefined;
    cityNameSecondaryLang?: string | undefined;
    sourceBranchID?: string | undefined;
    sourceAddress?: string | undefined;
    sourcePhoneNumber?: string | undefined;
}

export class CreateProfileForExistTaxpayerResponseDto implements ICreateProfileForExistTaxpayerResponseDto {
    id?: number;
    registrationNumber?: string | undefined;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;
    taxpayerTypePrimaryLang?: string | undefined;
    taxpayerTypeSecondaryLang?: string | undefined;
    taxpayerStatusPrimaryLang?: string | undefined;
    taxpayerStatusSecondaryLang?: string | undefined;
    operationStartDate?: Date;
    operationEndDate?: Date | undefined;
    establishmentDate?: Date | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    mobileNo?: string | undefined;
    address?: string | undefined;
    businessTradeName?: string | undefined;
    taxDistrictName?: string | undefined;
    isActive?: boolean;
    isVATEnabled?: boolean;
    taxpayerBranchs?: TaxpayerProfileBranchResponse[] | undefined;

    constructor(data?: ICreateProfileForExistTaxpayerResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.registrationNumber = _data["registrationNumber"];
            this.namePrimaryLang = _data["namePrimaryLang"];
            this.nameSecondaryLang = _data["nameSecondaryLang"];
            this.taxpayerTypePrimaryLang = _data["taxpayerTypePrimaryLang"];
            this.taxpayerTypeSecondaryLang = _data["taxpayerTypeSecondaryLang"];
            this.taxpayerStatusPrimaryLang = _data["taxpayerStatusPrimaryLang"];
            this.taxpayerStatusSecondaryLang = _data["taxpayerStatusSecondaryLang"];
            this.operationStartDate = _data["operationStartDate"] ? new Date(_data["operationStartDate"].toString()) : <any>undefined;
            this.operationEndDate = _data["operationEndDate"] ? new Date(_data["operationEndDate"].toString()) : <any>undefined;
            this.establishmentDate = _data["establishmentDate"] ? new Date(_data["establishmentDate"].toString()) : <any>undefined;
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.mobileNo = _data["mobileNo"];
            this.address = _data["address"];
            this.businessTradeName = _data["businessTradeName"];
            this.taxDistrictName = _data["taxDistrictName"];
            this.isActive = _data["isActive"];
            this.isVATEnabled = _data["isVATEnabled"];
            if (Array.isArray(_data["taxpayerBranchs"])) {
                this.taxpayerBranchs = [] as any;
                for (let item of _data["taxpayerBranchs"])
                    this.taxpayerBranchs!.push(TaxpayerProfileBranchResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateProfileForExistTaxpayerResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProfileForExistTaxpayerResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["registrationNumber"] = this.registrationNumber;
        data["namePrimaryLang"] = this.namePrimaryLang;
        data["nameSecondaryLang"] = this.nameSecondaryLang;
        data["taxpayerTypePrimaryLang"] = this.taxpayerTypePrimaryLang;
        data["taxpayerTypeSecondaryLang"] = this.taxpayerTypeSecondaryLang;
        data["taxpayerStatusPrimaryLang"] = this.taxpayerStatusPrimaryLang;
        data["taxpayerStatusSecondaryLang"] = this.taxpayerStatusSecondaryLang;
        data["operationStartDate"] = this.operationStartDate ? this.operationStartDate.toISOString() : <any>undefined;
        data["operationEndDate"] = this.operationEndDate ? this.operationEndDate.toISOString() : <any>undefined;
        data["establishmentDate"] = this.establishmentDate ? this.establishmentDate.toISOString() : <any>undefined;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["mobileNo"] = this.mobileNo;
        data["address"] = this.address;
        data["businessTradeName"] = this.businessTradeName;
        data["taxDistrictName"] = this.taxDistrictName;
        data["isActive"] = this.isActive;
        data["isVATEnabled"] = this.isVATEnabled;
        if (Array.isArray(this.taxpayerBranchs)) {
            data["taxpayerBranchs"] = [];
            for (let item of this.taxpayerBranchs)
                data["taxpayerBranchs"].push(item.toJSON());
        }
        return data; 
    }

    clone(): CreateProfileForExistTaxpayerResponseDto {
        const json = this.toJSON();
        let result = new CreateProfileForExistTaxpayerResponseDto();
        result.init(json);
        return result;
    }
}

export interface ICreateProfileForExistTaxpayerResponseDto {
    id?: number;
    registrationNumber?: string | undefined;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;
    taxpayerTypePrimaryLang?: string | undefined;
    taxpayerTypeSecondaryLang?: string | undefined;
    taxpayerStatusPrimaryLang?: string | undefined;
    taxpayerStatusSecondaryLang?: string | undefined;
    operationStartDate?: Date;
    operationEndDate?: Date | undefined;
    establishmentDate?: Date | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    mobileNo?: string | undefined;
    address?: string | undefined;
    businessTradeName?: string | undefined;
    taxDistrictName?: string | undefined;
    isActive?: boolean;
    isVATEnabled?: boolean;
    taxpayerBranchs?: TaxpayerProfileBranchResponse[] | undefined;
}

export class GetCurrentTaxpayerResponseDto implements IGetCurrentTaxpayerResponseDto {
    id?: number;
    registrationNumber?: string | undefined;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;
    taxpayerTypeName?: string | undefined;
    taxpayerStatusName?: string | undefined;
    operationStartDate?: Date;
    operationEndDate?: Date | undefined;
    establishmentDate?: Date | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    mobileNo?: string | undefined;
    address?: string | undefined;
    businessTradeName?: string | undefined;
    taxDistrictName?: string | undefined;
    isActive?: boolean;
    isVATEnabled?: boolean;
    language?: LanguageTypes;
    callbackUrl?: string | undefined;
    taxPayerAddress?: GetTaxpayerAddressDto;
    taxpayerBranchs?: GetTaxpayerBranchDto[] | undefined;
    taxpayersRepresentation?: GetRepresentationOfTaxpayerDto[] | undefined;

    constructor(data?: IGetCurrentTaxpayerResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.registrationNumber = _data["registrationNumber"];
            this.namePrimaryLang = _data["namePrimaryLang"];
            this.nameSecondaryLang = _data["nameSecondaryLang"];
            this.taxpayerTypeName = _data["taxpayerTypeName"];
            this.taxpayerStatusName = _data["taxpayerStatusName"];
            this.operationStartDate = _data["operationStartDate"] ? new Date(_data["operationStartDate"].toString()) : <any>undefined;
            this.operationEndDate = _data["operationEndDate"] ? new Date(_data["operationEndDate"].toString()) : <any>undefined;
            this.establishmentDate = _data["establishmentDate"] ? new Date(_data["establishmentDate"].toString()) : <any>undefined;
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.mobileNo = _data["mobileNo"];
            this.address = _data["address"];
            this.businessTradeName = _data["businessTradeName"];
            this.taxDistrictName = _data["taxDistrictName"];
            this.isActive = _data["isActive"];
            this.isVATEnabled = _data["isVATEnabled"];
            this.language = _data["language"];
            this.callbackUrl = _data["callbackUrl"];
            this.taxPayerAddress = _data["taxPayerAddress"] ? GetTaxpayerAddressDto.fromJS(_data["taxPayerAddress"]) : <any>undefined;
            if (Array.isArray(_data["taxpayerBranchs"])) {
                this.taxpayerBranchs = [] as any;
                for (let item of _data["taxpayerBranchs"])
                    this.taxpayerBranchs!.push(GetTaxpayerBranchDto.fromJS(item));
            }
            if (Array.isArray(_data["taxpayersRepresentation"])) {
                this.taxpayersRepresentation = [] as any;
                for (let item of _data["taxpayersRepresentation"])
                    this.taxpayersRepresentation!.push(GetRepresentationOfTaxpayerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCurrentTaxpayerResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentTaxpayerResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["registrationNumber"] = this.registrationNumber;
        data["namePrimaryLang"] = this.namePrimaryLang;
        data["nameSecondaryLang"] = this.nameSecondaryLang;
        data["taxpayerTypeName"] = this.taxpayerTypeName;
        data["taxpayerStatusName"] = this.taxpayerStatusName;
        data["operationStartDate"] = this.operationStartDate ? this.operationStartDate.toISOString() : <any>undefined;
        data["operationEndDate"] = this.operationEndDate ? this.operationEndDate.toISOString() : <any>undefined;
        data["establishmentDate"] = this.establishmentDate ? this.establishmentDate.toISOString() : <any>undefined;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["mobileNo"] = this.mobileNo;
        data["address"] = this.address;
        data["businessTradeName"] = this.businessTradeName;
        data["taxDistrictName"] = this.taxDistrictName;
        data["isActive"] = this.isActive;
        data["isVATEnabled"] = this.isVATEnabled;
        data["language"] = this.language;
        data["callbackUrl"] = this.callbackUrl;
        data["taxPayerAddress"] = this.taxPayerAddress ? this.taxPayerAddress.toJSON() : <any>undefined;
        if (Array.isArray(this.taxpayerBranchs)) {
            data["taxpayerBranchs"] = [];
            for (let item of this.taxpayerBranchs)
                data["taxpayerBranchs"].push(item.toJSON());
        }
        if (Array.isArray(this.taxpayersRepresentation)) {
            data["taxpayersRepresentation"] = [];
            for (let item of this.taxpayersRepresentation)
                data["taxpayersRepresentation"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetCurrentTaxpayerResponseDto {
        const json = this.toJSON();
        let result = new GetCurrentTaxpayerResponseDto();
        result.init(json);
        return result;
    }
}

export interface IGetCurrentTaxpayerResponseDto {
    id?: number;
    registrationNumber?: string | undefined;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;
    taxpayerTypeName?: string | undefined;
    taxpayerStatusName?: string | undefined;
    operationStartDate?: Date;
    operationEndDate?: Date | undefined;
    establishmentDate?: Date | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    mobileNo?: string | undefined;
    address?: string | undefined;
    businessTradeName?: string | undefined;
    taxDistrictName?: string | undefined;
    isActive?: boolean;
    isVATEnabled?: boolean;
    language?: LanguageTypes;
    callbackUrl?: string | undefined;
    taxPayerAddress?: GetTaxpayerAddressDto;
    taxpayerBranchs?: GetTaxpayerBranchDto[] | undefined;
    taxpayersRepresentation?: GetRepresentationOfTaxpayerDto[] | undefined;
}

export class TaxpayerAddressRequestDto implements ITaxpayerAddressRequestDto {
    streetName?: string | undefined;
    flatNo?: string | undefined;
    buildingNo?: string | undefined;
    cityID?: number | undefined;
    countryID?: number;
    countryCode?: string | undefined;
    governorateID?: number | undefined;
    floorNo?: string | undefined;
    additionalInformation?: string | undefined;
    postalCode?: string | undefined;
    streetName2?: string | undefined;
    foreignGovernorateName?: string | undefined;
    foreignCityName?: string | undefined;

    constructor(data?: ITaxpayerAddressRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.streetName = _data["streetName"];
            this.flatNo = _data["flatNo"];
            this.buildingNo = _data["buildingNo"];
            this.cityID = _data["cityID"];
            this.countryID = _data["countryID"];
            this.countryCode = _data["countryCode"];
            this.governorateID = _data["governorateID"];
            this.floorNo = _data["floorNo"];
            this.additionalInformation = _data["additionalInformation"];
            this.postalCode = _data["postalCode"];
            this.streetName2 = _data["streetName2"];
            this.foreignGovernorateName = _data["foreignGovernorateName"];
            this.foreignCityName = _data["foreignCityName"];
        }
    }

    static fromJS(data: any): TaxpayerAddressRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaxpayerAddressRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["streetName"] = this.streetName;
        data["flatNo"] = this.flatNo;
        data["buildingNo"] = this.buildingNo;
        data["cityID"] = this.cityID;
        data["countryID"] = this.countryID;
        data["countryCode"] = this.countryCode;
        data["governorateID"] = this.governorateID;
        data["floorNo"] = this.floorNo;
        data["additionalInformation"] = this.additionalInformation;
        data["postalCode"] = this.postalCode;
        data["streetName2"] = this.streetName2;
        data["foreignGovernorateName"] = this.foreignGovernorateName;
        data["foreignCityName"] = this.foreignCityName;
        return data; 
    }

    clone(): TaxpayerAddressRequestDto {
        const json = this.toJSON();
        let result = new TaxpayerAddressRequestDto();
        result.init(json);
        return result;
    }
}

export interface ITaxpayerAddressRequestDto {
    streetName?: string | undefined;
    flatNo?: string | undefined;
    buildingNo?: string | undefined;
    cityID?: number | undefined;
    countryID?: number;
    countryCode?: string | undefined;
    governorateID?: number | undefined;
    floorNo?: string | undefined;
    additionalInformation?: string | undefined;
    postalCode?: string | undefined;
    streetName2?: string | undefined;
    foreignGovernorateName?: string | undefined;
    foreignCityName?: string | undefined;
}

export class TaxpayerBranchRequestDto implements ITaxpayerBranchRequestDto {
    branchID?: number;
    branchName?: string | undefined;
    address?: TaxpayerAddressRequestDto;

    constructor(data?: ITaxpayerBranchRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branchID = _data["branchID"];
            this.branchName = _data["branchName"];
            this.address = _data["address"] ? TaxpayerAddressRequestDto.fromJS(_data["address"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TaxpayerBranchRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaxpayerBranchRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchID"] = this.branchID;
        data["branchName"] = this.branchName;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        return data; 
    }

    clone(): TaxpayerBranchRequestDto {
        const json = this.toJSON();
        let result = new TaxpayerBranchRequestDto();
        result.init(json);
        return result;
    }
}

export interface ITaxpayerBranchRequestDto {
    branchID?: number;
    branchName?: string | undefined;
    address?: TaxpayerAddressRequestDto;
}

export class UpdateCompanyProfileRequest implements IUpdateCompanyProfileRequest {
    namePrimaryLang?: string | undefined;
    email?: string | undefined;
    mobileNo?: string | undefined;
    preferredLanguage?: LanguageTypes;
    taxpayerBranchs?: TaxpayerBranchRequestDto[] | undefined;

    constructor(data?: IUpdateCompanyProfileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.namePrimaryLang = _data["namePrimaryLang"];
            this.email = _data["email"];
            this.mobileNo = _data["mobileNo"];
            this.preferredLanguage = _data["preferredLanguage"];
            if (Array.isArray(_data["taxpayerBranchs"])) {
                this.taxpayerBranchs = [] as any;
                for (let item of _data["taxpayerBranchs"])
                    this.taxpayerBranchs!.push(TaxpayerBranchRequestDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateCompanyProfileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCompanyProfileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["namePrimaryLang"] = this.namePrimaryLang;
        data["email"] = this.email;
        data["mobileNo"] = this.mobileNo;
        data["preferredLanguage"] = this.preferredLanguage;
        if (Array.isArray(this.taxpayerBranchs)) {
            data["taxpayerBranchs"] = [];
            for (let item of this.taxpayerBranchs)
                data["taxpayerBranchs"].push(item.toJSON());
        }
        return data; 
    }

    clone(): UpdateCompanyProfileRequest {
        const json = this.toJSON();
        let result = new UpdateCompanyProfileRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateCompanyProfileRequest {
    namePrimaryLang?: string | undefined;
    email?: string | undefined;
    mobileNo?: string | undefined;
    preferredLanguage?: LanguageTypes;
    taxpayerBranchs?: TaxpayerBranchRequestDto[] | undefined;
}

export class LookupsDto implements ILookupsDto {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    parentCode?: string | undefined;

    constructor(data?: ILookupsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.parentCode = _data["parentCode"];
        }
    }

    static fromJS(data: any): LookupsDto {
        data = typeof data === 'object' ? data : {};
        let result = new LookupsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["parentCode"] = this.parentCode;
        return data; 
    }

    clone(): LookupsDto {
        const json = this.toJSON();
        let result = new LookupsDto();
        result.init(json);
        return result;
    }
}

export interface ILookupsDto {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    parentCode?: string | undefined;
}

export class SearchLimitsDto implements ISearchLimitsDto {
    maxPageSize?: number;
    timeWindowIntervalInHrs?: number;

    constructor(data?: ISearchLimitsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxPageSize = _data["maxPageSize"];
            this.timeWindowIntervalInHrs = _data["timeWindowIntervalInHrs"];
        }
    }

    static fromJS(data: any): SearchLimitsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchLimitsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxPageSize"] = this.maxPageSize;
        data["timeWindowIntervalInHrs"] = this.timeWindowIntervalInHrs;
        return data; 
    }

    clone(): SearchLimitsDto {
        const json = this.toJSON();
        let result = new SearchLimitsDto();
        result.init(json);
        return result;
    }
}

export interface ISearchLimitsDto {
    maxPageSize?: number;
    timeWindowIntervalInHrs?: number;
}

export class GetLookupResponse implements IGetLookupResponse {
    cities?: LookupsDto[] | undefined;
    countries?: LookupsDto[] | undefined;
    governorates?: LookupsDto[] | undefined;
    statuses?: LookupsDto[] | undefined;
    userProfileTypes?: LookupsDto[] | undefined;
    contactTypes?: LookupsDto[] | undefined;
    languages?: LookupsDto[] | undefined;
    searchLimitsConfig?: SearchLimitsDto;

    constructor(data?: IGetLookupResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cities"])) {
                this.cities = [] as any;
                for (let item of _data["cities"])
                    this.cities!.push(LookupsDto.fromJS(item));
            }
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(LookupsDto.fromJS(item));
            }
            if (Array.isArray(_data["governorates"])) {
                this.governorates = [] as any;
                for (let item of _data["governorates"])
                    this.governorates!.push(LookupsDto.fromJS(item));
            }
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses!.push(LookupsDto.fromJS(item));
            }
            if (Array.isArray(_data["userProfileTypes"])) {
                this.userProfileTypes = [] as any;
                for (let item of _data["userProfileTypes"])
                    this.userProfileTypes!.push(LookupsDto.fromJS(item));
            }
            if (Array.isArray(_data["contactTypes"])) {
                this.contactTypes = [] as any;
                for (let item of _data["contactTypes"])
                    this.contactTypes!.push(LookupsDto.fromJS(item));
            }
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(LookupsDto.fromJS(item));
            }
            this.searchLimitsConfig = _data["searchLimitsConfig"] ? SearchLimitsDto.fromJS(_data["searchLimitsConfig"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetLookupResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetLookupResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cities)) {
            data["cities"] = [];
            for (let item of this.cities)
                data["cities"].push(item.toJSON());
        }
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item.toJSON());
        }
        if (Array.isArray(this.governorates)) {
            data["governorates"] = [];
            for (let item of this.governorates)
                data["governorates"].push(item.toJSON());
        }
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item.toJSON());
        }
        if (Array.isArray(this.userProfileTypes)) {
            data["userProfileTypes"] = [];
            for (let item of this.userProfileTypes)
                data["userProfileTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.contactTypes)) {
            data["contactTypes"] = [];
            for (let item of this.contactTypes)
                data["contactTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item.toJSON());
        }
        data["searchLimitsConfig"] = this.searchLimitsConfig ? this.searchLimitsConfig.toJSON() : <any>undefined;
        return data; 
    }

    clone(): GetLookupResponse {
        const json = this.toJSON();
        let result = new GetLookupResponse();
        result.init(json);
        return result;
    }
}

export interface IGetLookupResponse {
    cities?: LookupsDto[] | undefined;
    countries?: LookupsDto[] | undefined;
    governorates?: LookupsDto[] | undefined;
    statuses?: LookupsDto[] | undefined;
    userProfileTypes?: LookupsDto[] | undefined;
    contactTypes?: LookupsDto[] | undefined;
    languages?: LookupsDto[] | undefined;
    searchLimitsConfig?: SearchLimitsDto;
}

export class AddressViewModel implements IAddressViewModel {
    streetName?: string | undefined;
    flatNo?: string | undefined;
    buildingNo?: string | undefined;
    cityId?: number;
    cityNameAr?: string | undefined;
    cityNameEn?: string | undefined;
    countryId?: number;
    countryCode?: string | undefined;
    countryNameAr?: string | undefined;
    countryNameEn?: string | undefined;
    governorateId?: number;
    governorateNameAr?: string | undefined;
    governorateNameEn?: string | undefined;
    floorNo?: string | undefined;
    streetName2?: string | undefined;
    additionalInformation?: string | undefined;
    postalCode?: string | undefined;
    foreignGovernorateName?: string | undefined;
    foreignCityName?: string | undefined;
    formattedAddressAr?: string | undefined;
    formattedAddressEn?: string | undefined;

    constructor(data?: IAddressViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.streetName = _data["streetName"];
            this.flatNo = _data["flatNo"];
            this.buildingNo = _data["buildingNo"];
            this.cityId = _data["cityId"];
            this.cityNameAr = _data["cityNameAr"];
            this.cityNameEn = _data["cityNameEn"];
            this.countryId = _data["countryId"];
            this.countryCode = _data["countryCode"];
            this.countryNameAr = _data["countryNameAr"];
            this.countryNameEn = _data["countryNameEn"];
            this.governorateId = _data["governorateId"];
            this.governorateNameAr = _data["governorateNameAr"];
            this.governorateNameEn = _data["governorateNameEn"];
            this.floorNo = _data["floorNo"];
            this.streetName2 = _data["streetName2"];
            this.additionalInformation = _data["additionalInformation"];
            this.postalCode = _data["postalCode"];
            this.foreignGovernorateName = _data["foreignGovernorateName"];
            this.foreignCityName = _data["foreignCityName"];
            this.formattedAddressAr = _data["formattedAddressAr"];
            this.formattedAddressEn = _data["formattedAddressEn"];
        }
    }

    static fromJS(data: any): AddressViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddressViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["streetName"] = this.streetName;
        data["flatNo"] = this.flatNo;
        data["buildingNo"] = this.buildingNo;
        data["cityId"] = this.cityId;
        data["cityNameAr"] = this.cityNameAr;
        data["cityNameEn"] = this.cityNameEn;
        data["countryId"] = this.countryId;
        data["countryCode"] = this.countryCode;
        data["countryNameAr"] = this.countryNameAr;
        data["countryNameEn"] = this.countryNameEn;
        data["governorateId"] = this.governorateId;
        data["governorateNameAr"] = this.governorateNameAr;
        data["governorateNameEn"] = this.governorateNameEn;
        data["floorNo"] = this.floorNo;
        data["streetName2"] = this.streetName2;
        data["additionalInformation"] = this.additionalInformation;
        data["postalCode"] = this.postalCode;
        data["foreignGovernorateName"] = this.foreignGovernorateName;
        data["foreignCityName"] = this.foreignCityName;
        data["formattedAddressAr"] = this.formattedAddressAr;
        data["formattedAddressEn"] = this.formattedAddressEn;
        return data; 
    }

    clone(): AddressViewModel {
        const json = this.toJSON();
        let result = new AddressViewModel();
        result.init(json);
        return result;
    }
}

export interface IAddressViewModel {
    streetName?: string | undefined;
    flatNo?: string | undefined;
    buildingNo?: string | undefined;
    cityId?: number;
    cityNameAr?: string | undefined;
    cityNameEn?: string | undefined;
    countryId?: number;
    countryCode?: string | undefined;
    countryNameAr?: string | undefined;
    countryNameEn?: string | undefined;
    governorateId?: number;
    governorateNameAr?: string | undefined;
    governorateNameEn?: string | undefined;
    floorNo?: string | undefined;
    streetName2?: string | undefined;
    additionalInformation?: string | undefined;
    postalCode?: string | undefined;
    foreignGovernorateName?: string | undefined;
    foreignCityName?: string | undefined;
    formattedAddressAr?: string | undefined;
    formattedAddressEn?: string | undefined;
}

export class TaxpayerRepresentativeDto implements ITaxpayerRepresentativeDto {
    firstNamePrimaryLang?: string | undefined;
    firstNameSecondaryLang?: string | undefined;
    lastNamePrimaryLang?: string | undefined;
    lastNameSecondaryLang?: string | undefined;
    email?: string | undefined;
    mobileNo?: string | undefined;
    showGuidanceOnStart?: boolean | undefined;
    nationalID?: string | undefined;
    address?: AddressViewModel;

    constructor(data?: ITaxpayerRepresentativeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstNamePrimaryLang = _data["firstNamePrimaryLang"];
            this.firstNameSecondaryLang = _data["firstNameSecondaryLang"];
            this.lastNamePrimaryLang = _data["lastNamePrimaryLang"];
            this.lastNameSecondaryLang = _data["lastNameSecondaryLang"];
            this.email = _data["email"];
            this.mobileNo = _data["mobileNo"];
            this.showGuidanceOnStart = _data["showGuidanceOnStart"];
            this.nationalID = _data["nationalID"];
            this.address = _data["address"] ? AddressViewModel.fromJS(_data["address"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TaxpayerRepresentativeDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaxpayerRepresentativeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstNamePrimaryLang"] = this.firstNamePrimaryLang;
        data["firstNameSecondaryLang"] = this.firstNameSecondaryLang;
        data["lastNamePrimaryLang"] = this.lastNamePrimaryLang;
        data["lastNameSecondaryLang"] = this.lastNameSecondaryLang;
        data["email"] = this.email;
        data["mobileNo"] = this.mobileNo;
        data["showGuidanceOnStart"] = this.showGuidanceOnStart;
        data["nationalID"] = this.nationalID;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        return data; 
    }

    clone(): TaxpayerRepresentativeDto {
        const json = this.toJSON();
        let result = new TaxpayerRepresentativeDto();
        result.init(json);
        return result;
    }
}

export interface ITaxpayerRepresentativeDto {
    firstNamePrimaryLang?: string | undefined;
    firstNameSecondaryLang?: string | undefined;
    lastNamePrimaryLang?: string | undefined;
    lastNameSecondaryLang?: string | undefined;
    email?: string | undefined;
    mobileNo?: string | undefined;
    showGuidanceOnStart?: boolean | undefined;
    nationalID?: string | undefined;
    address?: AddressViewModel;
}

export class CreateUserProfileDto implements ICreateUserProfileDto {
    preferredLanguage?: LanguageTypes;
    password?: string | undefined;
    confirmPassword?: string | undefined;
    invitationID?: string | undefined;
    taxpayerRepresentative?: TaxpayerRepresentativeDto;

    constructor(data?: ICreateUserProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.preferredLanguage = _data["preferredLanguage"];
            this.password = _data["password"];
            this.confirmPassword = _data["confirmPassword"];
            this.invitationID = _data["invitationID"];
            this.taxpayerRepresentative = _data["taxpayerRepresentative"] ? TaxpayerRepresentativeDto.fromJS(_data["taxpayerRepresentative"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateUserProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preferredLanguage"] = this.preferredLanguage;
        data["password"] = this.password;
        data["confirmPassword"] = this.confirmPassword;
        data["invitationID"] = this.invitationID;
        data["taxpayerRepresentative"] = this.taxpayerRepresentative ? this.taxpayerRepresentative.toJSON() : <any>undefined;
        return data; 
    }

    clone(): CreateUserProfileDto {
        const json = this.toJSON();
        let result = new CreateUserProfileDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserProfileDto {
    preferredLanguage?: LanguageTypes;
    password?: string | undefined;
    confirmPassword?: string | undefined;
    invitationID?: string | undefined;
    taxpayerRepresentative?: TaxpayerRepresentativeDto;
}

export class CreateUserProfileResponse implements ICreateUserProfileResponse {
    isSuccess?: boolean;
    userProfileID?: number;
    loginID?: string | undefined;
    errors?: { [key: string]: string[]; } | undefined;

    constructor(data?: ICreateUserProfileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.userProfileID = _data["userProfileID"];
            this.loginID = _data["loginID"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        this.errors![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): CreateUserProfileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserProfileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["userProfileID"] = this.userProfileID;
        data["loginID"] = this.loginID;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    data["errors"][key] = this.errors[key];
            }
        }
        return data; 
    }

    clone(): CreateUserProfileResponse {
        const json = this.toJSON();
        let result = new CreateUserProfileResponse();
        result.init(json);
        return result;
    }
}

export interface ICreateUserProfileResponse {
    isSuccess?: boolean;
    userProfileID?: number;
    loginID?: string | undefined;
    errors?: { [key: string]: string[]; } | undefined;
}

export enum OrderDirections {
    Ascending = "Ascending",
    Descending = "Descending",
}

export class GetAddressDto implements IGetAddressDto {
    streetName?: string | undefined;
    cityNamePrimaryLang?: string | undefined;
    cityNameSecondaryLang?: string | undefined;
    countryNamePrimaryLang?: string | undefined;
    countryNameSecondaryLang?: string | undefined;

    constructor(data?: IGetAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.streetName = _data["streetName"];
            this.cityNamePrimaryLang = _data["cityNamePrimaryLang"];
            this.cityNameSecondaryLang = _data["cityNameSecondaryLang"];
            this.countryNamePrimaryLang = _data["countryNamePrimaryLang"];
            this.countryNameSecondaryLang = _data["countryNameSecondaryLang"];
        }
    }

    static fromJS(data: any): GetAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["streetName"] = this.streetName;
        data["cityNamePrimaryLang"] = this.cityNamePrimaryLang;
        data["cityNameSecondaryLang"] = this.cityNameSecondaryLang;
        data["countryNamePrimaryLang"] = this.countryNamePrimaryLang;
        data["countryNameSecondaryLang"] = this.countryNameSecondaryLang;
        return data; 
    }

    clone(): GetAddressDto {
        const json = this.toJSON();
        let result = new GetAddressDto();
        result.init(json);
        return result;
    }
}

export interface IGetAddressDto {
    streetName?: string | undefined;
    cityNamePrimaryLang?: string | undefined;
    cityNameSecondaryLang?: string | undefined;
    countryNamePrimaryLang?: string | undefined;
    countryNameSecondaryLang?: string | undefined;
}

export class SearchUserProfileDto implements ISearchUserProfileDto {
    profileID?: number;
    profileNamePrimaryLang?: string | undefined;
    profileNameSecondaryLang?: string | undefined;
    dateCreated?: Date;
    dateBlocked?: Date | undefined;
    status?: StatusTypes;
    userProfileType?: ProfileTypes;
    preferredLanguage?: LanguageTypes;
    firstNamePrimaryLang?: string | undefined;
    firstNameSecondaryLang?: string | undefined;
    lastNamePrimaryLang?: string | undefined;
    lastNameSecondaryLang?: string | undefined;
    email?: string | undefined;
    mobileNo?: string | undefined;
    nationalID?: string | undefined;
    address?: GetAddressDto;

    constructor(data?: ISearchUserProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profileID = _data["profileID"];
            this.profileNamePrimaryLang = _data["profileNamePrimaryLang"];
            this.profileNameSecondaryLang = _data["profileNameSecondaryLang"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : <any>undefined;
            this.dateBlocked = _data["dateBlocked"] ? new Date(_data["dateBlocked"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.userProfileType = _data["userProfileType"];
            this.preferredLanguage = _data["preferredLanguage"];
            this.firstNamePrimaryLang = _data["firstNamePrimaryLang"];
            this.firstNameSecondaryLang = _data["firstNameSecondaryLang"];
            this.lastNamePrimaryLang = _data["lastNamePrimaryLang"];
            this.lastNameSecondaryLang = _data["lastNameSecondaryLang"];
            this.email = _data["email"];
            this.mobileNo = _data["mobileNo"];
            this.nationalID = _data["nationalID"];
            this.address = _data["address"] ? GetAddressDto.fromJS(_data["address"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchUserProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchUserProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileID"] = this.profileID;
        data["profileNamePrimaryLang"] = this.profileNamePrimaryLang;
        data["profileNameSecondaryLang"] = this.profileNameSecondaryLang;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data["dateBlocked"] = this.dateBlocked ? this.dateBlocked.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["userProfileType"] = this.userProfileType;
        data["preferredLanguage"] = this.preferredLanguage;
        data["firstNamePrimaryLang"] = this.firstNamePrimaryLang;
        data["firstNameSecondaryLang"] = this.firstNameSecondaryLang;
        data["lastNamePrimaryLang"] = this.lastNamePrimaryLang;
        data["lastNameSecondaryLang"] = this.lastNameSecondaryLang;
        data["email"] = this.email;
        data["mobileNo"] = this.mobileNo;
        data["nationalID"] = this.nationalID;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        return data; 
    }

    clone(): SearchUserProfileDto {
        const json = this.toJSON();
        let result = new SearchUserProfileDto();
        result.init(json);
        return result;
    }
}

export interface ISearchUserProfileDto {
    profileID?: number;
    profileNamePrimaryLang?: string | undefined;
    profileNameSecondaryLang?: string | undefined;
    dateCreated?: Date;
    dateBlocked?: Date | undefined;
    status?: StatusTypes;
    userProfileType?: ProfileTypes;
    preferredLanguage?: LanguageTypes;
    firstNamePrimaryLang?: string | undefined;
    firstNameSecondaryLang?: string | undefined;
    lastNamePrimaryLang?: string | undefined;
    lastNameSecondaryLang?: string | undefined;
    email?: string | undefined;
    mobileNo?: string | undefined;
    nationalID?: string | undefined;
    address?: GetAddressDto;
}

export class MetaData implements IMetaData {
    totalPages?: number;
    totalCount?: number;

    constructor(data?: IMetaData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MetaData {
        data = typeof data === 'object' ? data : {};
        let result = new MetaData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        return data; 
    }

    clone(): MetaData {
        const json = this.toJSON();
        let result = new MetaData();
        result.init(json);
        return result;
    }
}

export interface IMetaData {
    totalPages?: number;
    totalCount?: number;
}

export class SearchUserProfileResponse implements ISearchUserProfileResponse {
    result?: SearchUserProfileDto[] | undefined;
    metadata?: MetaData;

    constructor(data?: ISearchUserProfileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(SearchUserProfileDto.fromJS(item));
            }
            this.metadata = _data["metadata"] ? MetaData.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchUserProfileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SearchUserProfileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        return data; 
    }

    clone(): SearchUserProfileResponse {
        const json = this.toJSON();
        let result = new SearchUserProfileResponse();
        result.init(json);
        return result;
    }
}

export interface ISearchUserProfileResponse {
    result?: SearchUserProfileDto[] | undefined;
    metadata?: MetaData;
}

export class UpdateUserContactInfoDto implements IUpdateUserContactInfoDto {
    mobileNumber?: string | undefined;
    emailAddress?: string | undefined;

    constructor(data?: IUpdateUserContactInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mobileNumber = _data["mobileNumber"];
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): UpdateUserContactInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserContactInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mobileNumber"] = this.mobileNumber;
        data["emailAddress"] = this.emailAddress;
        return data; 
    }

    clone(): UpdateUserContactInfoDto {
        const json = this.toJSON();
        let result = new UpdateUserContactInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserContactInfoDto {
    mobileNumber?: string | undefined;
    emailAddress?: string | undefined;
}

export class UpdateUserContactInfoResponseDto implements IUpdateUserContactInfoResponseDto {
    isSuccess?: boolean;

    constructor(data?: IUpdateUserContactInfoResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
        }
    }

    static fromJS(data: any): UpdateUserContactInfoResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserContactInfoResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        return data; 
    }

    clone(): UpdateUserContactInfoResponseDto {
        const json = this.toJSON();
        let result = new UpdateUserContactInfoResponseDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserContactInfoResponseDto {
    isSuccess?: boolean;
}

export class UserProfileAddressDto implements IUserProfileAddressDto {
    streetName?: string | undefined;
    flatNo?: string | undefined;
    buildingNo?: string | undefined;
    cityID?: number | undefined;
    countryID?: number;
    countryCode?: string | undefined;
    governorateID?: number | undefined;
    floorNo?: string | undefined;
    additionalInformation?: string | undefined;
    postalCode?: string | undefined;
    streetName2?: string | undefined;
    foreignGovernorateName?: string | undefined;
    foreignCityName?: string | undefined;

    constructor(data?: IUserProfileAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.streetName = _data["streetName"];
            this.flatNo = _data["flatNo"];
            this.buildingNo = _data["buildingNo"];
            this.cityID = _data["cityID"];
            this.countryID = _data["countryID"];
            this.countryCode = _data["countryCode"];
            this.governorateID = _data["governorateID"];
            this.floorNo = _data["floorNo"];
            this.additionalInformation = _data["additionalInformation"];
            this.postalCode = _data["postalCode"];
            this.streetName2 = _data["streetName2"];
            this.foreignGovernorateName = _data["foreignGovernorateName"];
            this.foreignCityName = _data["foreignCityName"];
        }
    }

    static fromJS(data: any): UserProfileAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfileAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["streetName"] = this.streetName;
        data["flatNo"] = this.flatNo;
        data["buildingNo"] = this.buildingNo;
        data["cityID"] = this.cityID;
        data["countryID"] = this.countryID;
        data["countryCode"] = this.countryCode;
        data["governorateID"] = this.governorateID;
        data["floorNo"] = this.floorNo;
        data["additionalInformation"] = this.additionalInformation;
        data["postalCode"] = this.postalCode;
        data["streetName2"] = this.streetName2;
        data["foreignGovernorateName"] = this.foreignGovernorateName;
        data["foreignCityName"] = this.foreignCityName;
        return data; 
    }

    clone(): UserProfileAddressDto {
        const json = this.toJSON();
        let result = new UserProfileAddressDto();
        result.init(json);
        return result;
    }
}

export interface IUserProfileAddressDto {
    streetName?: string | undefined;
    flatNo?: string | undefined;
    buildingNo?: string | undefined;
    cityID?: number | undefined;
    countryID?: number;
    countryCode?: string | undefined;
    governorateID?: number | undefined;
    floorNo?: string | undefined;
    additionalInformation?: string | undefined;
    postalCode?: string | undefined;
    streetName2?: string | undefined;
    foreignGovernorateName?: string | undefined;
    foreignCityName?: string | undefined;
}

export class UpdateCurrentUserProfileRequest implements IUpdateCurrentUserProfileRequest {
    preferredLanguage?: LanguageTypes;
    firstNamePrimaryLang?: string | undefined;
    firstNameSecondaryLang?: string | undefined;
    lastNamePrimaryLang?: string | undefined;
    lastNameSecondaryLang?: string | undefined;
    emailAddress?: string | undefined;
    mobileNumber?: string | undefined;
    showGuidanceOnStart?: boolean | undefined;
    address?: UserProfileAddressDto;

    constructor(data?: IUpdateCurrentUserProfileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.preferredLanguage = _data["preferredLanguage"];
            this.firstNamePrimaryLang = _data["firstNamePrimaryLang"];
            this.firstNameSecondaryLang = _data["firstNameSecondaryLang"];
            this.lastNamePrimaryLang = _data["lastNamePrimaryLang"];
            this.lastNameSecondaryLang = _data["lastNameSecondaryLang"];
            this.emailAddress = _data["emailAddress"];
            this.mobileNumber = _data["mobileNumber"];
            this.showGuidanceOnStart = _data["showGuidanceOnStart"];
            this.address = _data["address"] ? UserProfileAddressDto.fromJS(_data["address"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateCurrentUserProfileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCurrentUserProfileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preferredLanguage"] = this.preferredLanguage;
        data["firstNamePrimaryLang"] = this.firstNamePrimaryLang;
        data["firstNameSecondaryLang"] = this.firstNameSecondaryLang;
        data["lastNamePrimaryLang"] = this.lastNamePrimaryLang;
        data["lastNameSecondaryLang"] = this.lastNameSecondaryLang;
        data["emailAddress"] = this.emailAddress;
        data["mobileNumber"] = this.mobileNumber;
        data["showGuidanceOnStart"] = this.showGuidanceOnStart;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        return data; 
    }

    clone(): UpdateCurrentUserProfileRequest {
        const json = this.toJSON();
        let result = new UpdateCurrentUserProfileRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateCurrentUserProfileRequest {
    preferredLanguage?: LanguageTypes;
    firstNamePrimaryLang?: string | undefined;
    firstNameSecondaryLang?: string | undefined;
    lastNamePrimaryLang?: string | undefined;
    lastNameSecondaryLang?: string | undefined;
    emailAddress?: string | undefined;
    mobileNumber?: string | undefined;
    showGuidanceOnStart?: boolean | undefined;
    address?: UserProfileAddressDto;
}

export class SigningCertificateDto implements ISigningCertificateDto {
    signingCertificateID?: number;
    issuerSubjectName?: string | undefined;
    subjectName?: string | undefined;
    certificateContents?: string | undefined;
    subjectKey?: string | undefined;

    constructor(data?: ISigningCertificateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.signingCertificateID = _data["signingCertificateID"];
            this.issuerSubjectName = _data["issuerSubjectName"];
            this.subjectName = _data["subjectName"];
            this.certificateContents = _data["certificateContents"];
            this.subjectKey = _data["subjectKey"];
        }
    }

    static fromJS(data: any): SigningCertificateDto {
        data = typeof data === 'object' ? data : {};
        let result = new SigningCertificateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signingCertificateID"] = this.signingCertificateID;
        data["issuerSubjectName"] = this.issuerSubjectName;
        data["subjectName"] = this.subjectName;
        data["certificateContents"] = this.certificateContents;
        data["subjectKey"] = this.subjectKey;
        return data; 
    }

    clone(): SigningCertificateDto {
        const json = this.toJSON();
        let result = new SigningCertificateDto();
        result.init(json);
        return result;
    }
}

export interface ISigningCertificateDto {
    signingCertificateID?: number;
    issuerSubjectName?: string | undefined;
    subjectName?: string | undefined;
    certificateContents?: string | undefined;
    subjectKey?: string | undefined;
}

export class TaxpayerRepresentationDto implements ITaxpayerRepresentationDto {
    taxpayerRepresentationID?: number;
    isAdministrator?: boolean;
    representationInvitationId?: number;
    taxpayerID?: number;
    taxpayerNameAr?: string | undefined;
    taxpayerNameEn?: string | undefined;
    registrationNumber?: string | undefined;
    taxpayerActivity?: string | undefined;
    governorateNameAr?: string | undefined;
    governorateNameEn?: string | undefined;
    dateActivated?: Date;
    dateDeactivated?: Date | undefined;
    status?: StatusTypes;
    userProfileStatus?: StatusTypes;

    constructor(data?: ITaxpayerRepresentationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxpayerRepresentationID = _data["taxpayerRepresentationID"];
            this.isAdministrator = _data["isAdministrator"];
            this.representationInvitationId = _data["representationInvitationId"];
            this.taxpayerID = _data["taxpayerID"];
            this.taxpayerNameAr = _data["taxpayerNameAr"];
            this.taxpayerNameEn = _data["taxpayerNameEn"];
            this.registrationNumber = _data["registrationNumber"];
            this.taxpayerActivity = _data["taxpayerActivity"];
            this.governorateNameAr = _data["governorateNameAr"];
            this.governorateNameEn = _data["governorateNameEn"];
            this.dateActivated = _data["dateActivated"] ? new Date(_data["dateActivated"].toString()) : <any>undefined;
            this.dateDeactivated = _data["dateDeactivated"] ? new Date(_data["dateDeactivated"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.userProfileStatus = _data["userProfileStatus"];
        }
    }

    static fromJS(data: any): TaxpayerRepresentationDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaxpayerRepresentationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxpayerRepresentationID"] = this.taxpayerRepresentationID;
        data["isAdministrator"] = this.isAdministrator;
        data["representationInvitationId"] = this.representationInvitationId;
        data["taxpayerID"] = this.taxpayerID;
        data["taxpayerNameAr"] = this.taxpayerNameAr;
        data["taxpayerNameEn"] = this.taxpayerNameEn;
        data["registrationNumber"] = this.registrationNumber;
        data["taxpayerActivity"] = this.taxpayerActivity;
        data["governorateNameAr"] = this.governorateNameAr;
        data["governorateNameEn"] = this.governorateNameEn;
        data["dateActivated"] = this.dateActivated ? this.dateActivated.toISOString() : <any>undefined;
        data["dateDeactivated"] = this.dateDeactivated ? this.dateDeactivated.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["userProfileStatus"] = this.userProfileStatus;
        return data; 
    }

    clone(): TaxpayerRepresentationDto {
        const json = this.toJSON();
        let result = new TaxpayerRepresentationDto();
        result.init(json);
        return result;
    }
}

export interface ITaxpayerRepresentationDto {
    taxpayerRepresentationID?: number;
    isAdministrator?: boolean;
    representationInvitationId?: number;
    taxpayerID?: number;
    taxpayerNameAr?: string | undefined;
    taxpayerNameEn?: string | undefined;
    registrationNumber?: string | undefined;
    taxpayerActivity?: string | undefined;
    governorateNameAr?: string | undefined;
    governorateNameEn?: string | undefined;
    dateActivated?: Date;
    dateDeactivated?: Date | undefined;
    status?: StatusTypes;
    userProfileStatus?: StatusTypes;
}

export enum Provider {
    UserNamePassword = "UserNamePassword",
    PreSharedKey = "PreSharedKey",
}

export class CredentialDto implements ICredentialDto {
    id?: number;
    providerID?: Provider;
    loginID?: string | undefined;
    validTo?: Date | undefined;
    validFrom?: Date | undefined;

    constructor(data?: ICredentialDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.providerID = _data["providerID"];
            this.loginID = _data["loginID"];
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : <any>undefined;
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CredentialDto {
        data = typeof data === 'object' ? data : {};
        let result = new CredentialDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["providerID"] = this.providerID;
        data["loginID"] = this.loginID;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        return data; 
    }

    clone(): CredentialDto {
        const json = this.toJSON();
        let result = new CredentialDto();
        result.init(json);
        return result;
    }
}

export interface ICredentialDto {
    id?: number;
    providerID?: Provider;
    loginID?: string | undefined;
    validTo?: Date | undefined;
    validFrom?: Date | undefined;
}

export class GetCurrentUserDetailsQueryResponseDto implements IGetCurrentUserDetailsQueryResponseDto {
    dateCreated?: Date;
    dateBlocked?: Date | undefined;
    preferredLanguage?: LanguageTypes;
    status?: StatusTypes;
    taxpayerRepresentative?: TaxpayerRepresentativeDto;
    signingCertificate?: SigningCertificateDto;
    taxpayerRepresentations?: TaxpayerRepresentationDto[] | undefined;
    credentials?: CredentialDto[] | undefined;

    constructor(data?: IGetCurrentUserDetailsQueryResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : <any>undefined;
            this.dateBlocked = _data["dateBlocked"] ? new Date(_data["dateBlocked"].toString()) : <any>undefined;
            this.preferredLanguage = _data["preferredLanguage"];
            this.status = _data["status"];
            this.taxpayerRepresentative = _data["taxpayerRepresentative"] ? TaxpayerRepresentativeDto.fromJS(_data["taxpayerRepresentative"]) : <any>undefined;
            this.signingCertificate = _data["signingCertificate"] ? SigningCertificateDto.fromJS(_data["signingCertificate"]) : <any>undefined;
            if (Array.isArray(_data["taxpayerRepresentations"])) {
                this.taxpayerRepresentations = [] as any;
                for (let item of _data["taxpayerRepresentations"])
                    this.taxpayerRepresentations!.push(TaxpayerRepresentationDto.fromJS(item));
            }
            if (Array.isArray(_data["credentials"])) {
                this.credentials = [] as any;
                for (let item of _data["credentials"])
                    this.credentials!.push(CredentialDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCurrentUserDetailsQueryResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentUserDetailsQueryResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data["dateBlocked"] = this.dateBlocked ? this.dateBlocked.toISOString() : <any>undefined;
        data["preferredLanguage"] = this.preferredLanguage;
        data["status"] = this.status;
        data["taxpayerRepresentative"] = this.taxpayerRepresentative ? this.taxpayerRepresentative.toJSON() : <any>undefined;
        data["signingCertificate"] = this.signingCertificate ? this.signingCertificate.toJSON() : <any>undefined;
        if (Array.isArray(this.taxpayerRepresentations)) {
            data["taxpayerRepresentations"] = [];
            for (let item of this.taxpayerRepresentations)
                data["taxpayerRepresentations"].push(item.toJSON());
        }
        if (Array.isArray(this.credentials)) {
            data["credentials"] = [];
            for (let item of this.credentials)
                data["credentials"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetCurrentUserDetailsQueryResponseDto {
        const json = this.toJSON();
        let result = new GetCurrentUserDetailsQueryResponseDto();
        result.init(json);
        return result;
    }
}

export interface IGetCurrentUserDetailsQueryResponseDto {
    dateCreated?: Date;
    dateBlocked?: Date | undefined;
    preferredLanguage?: LanguageTypes;
    status?: StatusTypes;
    taxpayerRepresentative?: TaxpayerRepresentativeDto;
    signingCertificate?: SigningCertificateDto;
    taxpayerRepresentations?: TaxpayerRepresentationDto[] | undefined;
    credentials?: CredentialDto[] | undefined;
}

export class ValidateUserOTPRequest implements IValidateUserOTPRequest {
    validationType?: ValidationType;

    constructor(data?: IValidateUserOTPRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.validationType = _data["validationType"];
        }
    }

    static fromJS(data: any): ValidateUserOTPRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateUserOTPRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validationType"] = this.validationType;
        return data; 
    }

    clone(): ValidateUserOTPRequest {
        const json = this.toJSON();
        let result = new ValidateUserOTPRequest();
        result.init(json);
        return result;
    }
}

export interface IValidateUserOTPRequest {
    validationType?: ValidationType;
}

export class ValidateOTPResponse implements IValidateOTPResponse {
    isSuccess?: boolean;

    constructor(data?: IValidateOTPResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
        }
    }

    static fromJS(data: any): ValidateOTPResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateOTPResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        return data; 
    }

    clone(): ValidateOTPResponse {
        const json = this.toJSON();
        let result = new ValidateOTPResponse();
        result.init(json);
        return result;
    }
}

export interface IValidateOTPResponse {
    isSuccess?: boolean;
}

export class UserStatusUpdateDto implements IUserStatusUpdateDto {
    status?: ProfileStatus;
    reason?: string | undefined;

    constructor(data?: IUserStatusUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): UserStatusUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserStatusUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["reason"] = this.reason;
        return data; 
    }

    clone(): UserStatusUpdateDto {
        const json = this.toJSON();
        let result = new UserStatusUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IUserStatusUpdateDto {
    status?: ProfileStatus;
    reason?: string | undefined;
}

export class UserStatusUpdateResponse implements IUserStatusUpdateResponse {
    id?: number;

    constructor(data?: IUserStatusUpdateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserStatusUpdateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserStatusUpdateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }

    clone(): UserStatusUpdateResponse {
        const json = this.toJSON();
        let result = new UserStatusUpdateResponse();
        result.init(json);
        return result;
    }
}

export interface IUserStatusUpdateResponse {
    id?: number;
}

export class GetUserDetailsQueryResponseDto implements IGetUserDetailsQueryResponseDto {
    dateCreated?: Date;
    dateBlocked?: Date | undefined;
    preferredLanguage?: LanguageTypes;
    status?: StatusTypes;
    taxpayerRepresentative?: TaxpayerRepresentativeDto;
    signingCertificate?: SigningCertificateDto;
    taxpayerRepresentations?: TaxpayerRepresentationDto[] | undefined;
    credentials?: CredentialDto[] | undefined;

    constructor(data?: IGetUserDetailsQueryResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : <any>undefined;
            this.dateBlocked = _data["dateBlocked"] ? new Date(_data["dateBlocked"].toString()) : <any>undefined;
            this.preferredLanguage = _data["preferredLanguage"];
            this.status = _data["status"];
            this.taxpayerRepresentative = _data["taxpayerRepresentative"] ? TaxpayerRepresentativeDto.fromJS(_data["taxpayerRepresentative"]) : <any>undefined;
            this.signingCertificate = _data["signingCertificate"] ? SigningCertificateDto.fromJS(_data["signingCertificate"]) : <any>undefined;
            if (Array.isArray(_data["taxpayerRepresentations"])) {
                this.taxpayerRepresentations = [] as any;
                for (let item of _data["taxpayerRepresentations"])
                    this.taxpayerRepresentations!.push(TaxpayerRepresentationDto.fromJS(item));
            }
            if (Array.isArray(_data["credentials"])) {
                this.credentials = [] as any;
                for (let item of _data["credentials"])
                    this.credentials!.push(CredentialDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUserDetailsQueryResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserDetailsQueryResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data["dateBlocked"] = this.dateBlocked ? this.dateBlocked.toISOString() : <any>undefined;
        data["preferredLanguage"] = this.preferredLanguage;
        data["status"] = this.status;
        data["taxpayerRepresentative"] = this.taxpayerRepresentative ? this.taxpayerRepresentative.toJSON() : <any>undefined;
        data["signingCertificate"] = this.signingCertificate ? this.signingCertificate.toJSON() : <any>undefined;
        if (Array.isArray(this.taxpayerRepresentations)) {
            data["taxpayerRepresentations"] = [];
            for (let item of this.taxpayerRepresentations)
                data["taxpayerRepresentations"].push(item.toJSON());
        }
        if (Array.isArray(this.credentials)) {
            data["credentials"] = [];
            for (let item of this.credentials)
                data["credentials"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetUserDetailsQueryResponseDto {
        const json = this.toJSON();
        let result = new GetUserDetailsQueryResponseDto();
        result.init(json);
        return result;
    }
}

export interface IGetUserDetailsQueryResponseDto {
    dateCreated?: Date;
    dateBlocked?: Date | undefined;
    preferredLanguage?: LanguageTypes;
    status?: StatusTypes;
    taxpayerRepresentative?: TaxpayerRepresentativeDto;
    signingCertificate?: SigningCertificateDto;
    taxpayerRepresentations?: TaxpayerRepresentationDto[] | undefined;
    credentials?: CredentialDto[] | undefined;
}

export class TaxpayerRepresentationResponseDto implements ITaxpayerRepresentationResponseDto {
    dateActivated?: Date;
    dateDeactivated?: Date | undefined;
    isAdministrator?: boolean;
    registrationNumber?: string | undefined;
    taxpayerId?: number;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;
    isActive?: boolean;

    constructor(data?: ITaxpayerRepresentationResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateActivated = _data["dateActivated"] ? new Date(_data["dateActivated"].toString()) : <any>undefined;
            this.dateDeactivated = _data["dateDeactivated"] ? new Date(_data["dateDeactivated"].toString()) : <any>undefined;
            this.isAdministrator = _data["isAdministrator"];
            this.registrationNumber = _data["registrationNumber"];
            this.taxpayerId = _data["taxpayerId"];
            this.namePrimaryLang = _data["namePrimaryLang"];
            this.nameSecondaryLang = _data["nameSecondaryLang"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): TaxpayerRepresentationResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaxpayerRepresentationResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateActivated"] = this.dateActivated ? this.dateActivated.toISOString() : <any>undefined;
        data["dateDeactivated"] = this.dateDeactivated ? this.dateDeactivated.toISOString() : <any>undefined;
        data["isAdministrator"] = this.isAdministrator;
        data["registrationNumber"] = this.registrationNumber;
        data["taxpayerId"] = this.taxpayerId;
        data["namePrimaryLang"] = this.namePrimaryLang;
        data["nameSecondaryLang"] = this.nameSecondaryLang;
        data["isActive"] = this.isActive;
        return data; 
    }

    clone(): TaxpayerRepresentationResponseDto {
        const json = this.toJSON();
        let result = new TaxpayerRepresentationResponseDto();
        result.init(json);
        return result;
    }
}

export interface ITaxpayerRepresentationResponseDto {
    dateActivated?: Date;
    dateDeactivated?: Date | undefined;
    isAdministrator?: boolean;
    registrationNumber?: string | undefined;
    taxpayerId?: number;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;
    isActive?: boolean;
}

export class GetTaxpayerRepresentationResponseDto implements IGetTaxpayerRepresentationResponseDto {
    taxpayersRepresentationNow?: TaxpayerRepresentationResponseDto[] | undefined;
    taxpayersRepresentationPrevious?: TaxpayerRepresentationResponseDto[] | undefined;

    constructor(data?: IGetTaxpayerRepresentationResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["taxpayersRepresentationNow"])) {
                this.taxpayersRepresentationNow = [] as any;
                for (let item of _data["taxpayersRepresentationNow"])
                    this.taxpayersRepresentationNow!.push(TaxpayerRepresentationResponseDto.fromJS(item));
            }
            if (Array.isArray(_data["taxpayersRepresentationPrevious"])) {
                this.taxpayersRepresentationPrevious = [] as any;
                for (let item of _data["taxpayersRepresentationPrevious"])
                    this.taxpayersRepresentationPrevious!.push(TaxpayerRepresentationResponseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTaxpayerRepresentationResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTaxpayerRepresentationResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.taxpayersRepresentationNow)) {
            data["taxpayersRepresentationNow"] = [];
            for (let item of this.taxpayersRepresentationNow)
                data["taxpayersRepresentationNow"].push(item.toJSON());
        }
        if (Array.isArray(this.taxpayersRepresentationPrevious)) {
            data["taxpayersRepresentationPrevious"] = [];
            for (let item of this.taxpayersRepresentationPrevious)
                data["taxpayersRepresentationPrevious"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetTaxpayerRepresentationResponseDto {
        const json = this.toJSON();
        let result = new GetTaxpayerRepresentationResponseDto();
        result.init(json);
        return result;
    }
}

export interface IGetTaxpayerRepresentationResponseDto {
    taxpayersRepresentationNow?: TaxpayerRepresentationResponseDto[] | undefined;
    taxpayersRepresentationPrevious?: TaxpayerRepresentationResponseDto[] | undefined;
}

export class GetCredentialsDto implements IGetCredentialsDto {
    loginID?: string | undefined;
    providerID?: string | undefined;
    validFrom?: Date | undefined;
    validTo?: Date | undefined;

    constructor(data?: IGetCredentialsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loginID = _data["loginID"];
            this.providerID = _data["providerID"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCredentialsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCredentialsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loginID"] = this.loginID;
        data["providerID"] = this.providerID;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        return data; 
    }

    clone(): GetCredentialsDto {
        const json = this.toJSON();
        let result = new GetCredentialsDto();
        result.init(json);
        return result;
    }
}

export interface IGetCredentialsDto {
    loginID?: string | undefined;
    providerID?: string | undefined;
    validFrom?: Date | undefined;
    validTo?: Date | undefined;
}

export class GetUserProfileCredentialResponseDto implements IGetUserProfileCredentialResponseDto {
    profileID?: number;
    profileNamePrimaryLang?: string | undefined;
    profileNameSecondaryLang?: string | undefined;
    dateCreated?: Date;
    dateBlocked?: Date | undefined;
    status?: StatusTypes;
    userProfileType?: ProfileTypes;
    preferredLanguage?: LanguageTypes;
    email?: string | undefined;
    mobileNo?: string | undefined;
    nationalID?: string | undefined;
    taxpayersRepresentation?: GetTaxpayerRepresentationResponseDto;
    credentials?: GetCredentialsDto[] | undefined;

    constructor(data?: IGetUserProfileCredentialResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profileID = _data["profileID"];
            this.profileNamePrimaryLang = _data["profileNamePrimaryLang"];
            this.profileNameSecondaryLang = _data["profileNameSecondaryLang"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : <any>undefined;
            this.dateBlocked = _data["dateBlocked"] ? new Date(_data["dateBlocked"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.userProfileType = _data["userProfileType"];
            this.preferredLanguage = _data["preferredLanguage"];
            this.email = _data["email"];
            this.mobileNo = _data["mobileNo"];
            this.nationalID = _data["nationalID"];
            this.taxpayersRepresentation = _data["taxpayersRepresentation"] ? GetTaxpayerRepresentationResponseDto.fromJS(_data["taxpayersRepresentation"]) : <any>undefined;
            if (Array.isArray(_data["credentials"])) {
                this.credentials = [] as any;
                for (let item of _data["credentials"])
                    this.credentials!.push(GetCredentialsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUserProfileCredentialResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserProfileCredentialResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileID"] = this.profileID;
        data["profileNamePrimaryLang"] = this.profileNamePrimaryLang;
        data["profileNameSecondaryLang"] = this.profileNameSecondaryLang;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data["dateBlocked"] = this.dateBlocked ? this.dateBlocked.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["userProfileType"] = this.userProfileType;
        data["preferredLanguage"] = this.preferredLanguage;
        data["email"] = this.email;
        data["mobileNo"] = this.mobileNo;
        data["nationalID"] = this.nationalID;
        data["taxpayersRepresentation"] = this.taxpayersRepresentation ? this.taxpayersRepresentation.toJSON() : <any>undefined;
        if (Array.isArray(this.credentials)) {
            data["credentials"] = [];
            for (let item of this.credentials)
                data["credentials"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetUserProfileCredentialResponseDto {
        const json = this.toJSON();
        let result = new GetUserProfileCredentialResponseDto();
        result.init(json);
        return result;
    }
}

export interface IGetUserProfileCredentialResponseDto {
    profileID?: number;
    profileNamePrimaryLang?: string | undefined;
    profileNameSecondaryLang?: string | undefined;
    dateCreated?: Date;
    dateBlocked?: Date | undefined;
    status?: StatusTypes;
    userProfileType?: ProfileTypes;
    preferredLanguage?: LanguageTypes;
    email?: string | undefined;
    mobileNo?: string | undefined;
    nationalID?: string | undefined;
    taxpayersRepresentation?: GetTaxpayerRepresentationResponseDto;
    credentials?: GetCredentialsDto[] | undefined;
}

// export class ApiException extends Error {
//     message: string;
//     status: number;
//     response: string;
//     headers: { [key: string]: any; };
//     result: any;

//     constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
//         super();

//         this.message = message;
//         this.status = status;
//         this.response = response;
//         this.headers = headers;
//         this.result = result;
//     }

//     protected isApiException = true;

//     static isApiException(obj: any): obj is ApiException {
//         return obj.isApiException === true;
//     }
// }

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}